(window.theme = window.theme || {}),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var s = 0, r = e.options.length; s < r; s++) {
      var i = e.options[s];
      if (t == i.value || t == i.innerHTML) return (e.selectedIndex = s);
    }
  }),
  (Shopify.addListener = function (e, t, s) {
    e.addEventListener
      ? e.addEventListener(t, s, !1)
      : e.attachEvent("on" + t, s);
  }),
  (Shopify.postLink = function (e, t) {
    var s,
      r = (t = t || {}).method || "post",
      i = t.parameters || {},
      n = document.createElement("form");
    for (s in (n.setAttribute("method", r), n.setAttribute("action", e), i)) {
      var o = document.createElement("input");
      o.setAttribute("type", "hidden"),
        o.setAttribute("name", s),
        o.setAttribute("value", i[s]),
        n.appendChild(o);
    }
    document.body.appendChild(n), n.submit(), document.body.removeChild(n);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, s) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(s.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        0 < this.provinceEl.options.length &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (r =
        this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces"
        ),
        s = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var r, i = 0; i < s.length; i++)
          ((r = document.createElement("option")).value = s[i][0]),
            (r.innerHTML = s[i][1]),
            this.provinceEl.appendChild(r);
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var s = 0;
      for (t.length; s < t.length; s++) {
        var r = document.createElement("option");
        (r.value = t[s]), (r.innerHTML = t[s]), e.appendChild(r);
      }
    },
  }),
  (theme.config = {
    mediaQueries: {
      landscapeAll: "screen and (orientation: landscape)",
      landscape:
        "screen and (orientation: landscape), screen and (min-width: 48rem)",
      belowTablet: "screen and (max-width: 47.99rem)",
      tablet: "screen and (min-width: 48rem)",
      belowLaptop: "screen and (max-width: 63.99rem)",
      laptop: "screen and (min-width: 64rem)",
      belowDesktop: "screen and (max-width: 64rem)",
      desktop: "screen and (min-width: 64.01rem)",
      belowWidescreen: "screen and (max-width: 79.99rem)",
      widescreen: "screen and (min-width: 80rem)",
      belowExtrawide: "screen and (max-width: 89.99rem)",
      extrawide: "screen and (min-width: 90rem)",
    },
    money: {
      format: `${window.currency.symbol || "$"}{{amount}}`,
      currencySymbols: {
        USD: "$",
        CAD: "$",
        EUR: "€",
        CRC: "₡",
        GBP: "£",
        ILS: "₪",
        INR: "₹",
        JPY: "¥",
        KRW: "₩",
        NGN: "₦",
        PHP: "₱",
        PLN: "zł",
        PYG: "₲",
        THB: "฿",
        UAH: "₴",
        VND: "₫",
      },
    },
    money_format_no_trailing_zeros: `${window.currency.symbol || "$"}{{no_trailing_zeros}}`,
    upsellLimit: 6,
  }),
  (theme.utils = {
    subscriptions: {
      subscribers: {},
      subscribe(e, t) {
        return (
          void 0 === theme.utils.subscriptions.subscribers[e] &&
          (theme.utils.subscriptions.subscribers[e] = []),
          (theme.utils.subscriptions.subscribers[e] = [
            ...theme.utils.subscriptions.subscribers[e],
            t,
          ]),
          function () {
            theme.utils.subscriptions.subscribers[e] =
              theme.utils.subscriptions.subscribers[e].filter((e) => e !== t);
          }
        );
      },
      publish(e, t) {
        theme.utils.subscriptions.subscribers[e] &&
          theme.utils.subscriptions.subscribers[e].forEach((e) => {
            e(t);
          });
      },
    },
    a11y: {
      getFocusableElements(e) {
        return Array.from(
          e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        );
      },
      _trapFocusHandlers: {},
      trapFocus(t, e = t) {
        var s = theme.utils.a11y.getFocusableElements(t),
          r = s[0],
          i = s[s.length - 1];
        theme.utils.a11y.removeTrapFocus(),
          (theme.utils.a11y._trapFocusHandlers.focusin = (e) => {
            (e.target !== t && e.target !== i && e.target !== r) ||
              document.addEventListener(
                "keydown",
                theme.utils.a11y._trapFocusHandlers.keydown
              );
          }),
          (theme.utils.a11y._trapFocusHandlers.focusout = function () {
            document.removeEventListener(
              "keydown",
              theme.utils.a11y._trapFocusHandlers.keydown
            );
          }),
          (theme.utils.a11y._trapFocusHandlers.keydown = function (e) {
            "TAB" === e.code.toUpperCase() &&
              (e.target !== i || e.shiftKey || (e.preventDefault(), r.focus()),
                e.target === t || e.target === r) &&
              e.shiftKey &&
              (e.preventDefault(), i.focus());
          }),
          document.addEventListener(
            "focusout",
            theme.utils.a11y._trapFocusHandlers.focusout
          ),
          document.addEventListener(
            "focusin",
            theme.utils.a11y._trapFocusHandlers.focusin
          ),
          e.focus();
      },
      removeTrapFocus(e = null) {
        document.removeEventListener(
          "focusin",
          theme.utils.a11y._trapFocusHandlers.focusin
        ),
          document.removeEventListener(
            "focusout",
            theme.utils.a11y._trapFocusHandlers.focusout
          ),
          document.removeEventListener(
            "keydown",
            theme.utils.a11y._trapFocusHandlers.keydown
          ),
          e && e.focus();
      },
    },
    prepareTransition(e) {
      e.addEventListener("transitionend", () => {
        e.classList.remove("is-transitioning");
      });
      let t = 0;
      const s = getComputedStyle(e);
      [
        "transition-duration",
        "-moz-transition-duration",
        "-webkit-transition-duration",
        "-o-transition-duration",
      ].forEach((e) => (t = t || parseFloat(s.getPropertyValue(e)))),
        0 != t && (e.classList.add("is-transitioning"), e.offsetWidth);
    },
    defaultTo: function (e, t) {
      return null == e || e != e ? t : e;
    },
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var s = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        o = t || theme.config.money.format;
      function r(e, t, s, r) {
        if (
          ((t = theme.utils.defaultTo(t, 2)),
            (s = theme.utils.defaultTo(s, ",")),
            (r = theme.utils.defaultTo(r, ".")),
            isNaN(e) || null == e)
        )
          return 0;
        (t = (e = (e / 100).toFixed(t)).split(".")),
          (e = t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s));
        let i = t[1] ? r + t[1] : "";
        return (
          e + (i = "no_trailing_zeros" == o.match(n)[1] && ".00" == i ? "" : i)
        );
      }
      switch (o.match(n)[1]) {
        case "amount":
          s = r(e, 2);
          break;
        case "amount_no_decimals":
          s = r(e, 0);
          break;
        case "amount_with_space_separator":
          s = r(e, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = r(e, 0, ",", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          s = r(e, 0, " ");
          break;
        case "no_trailing_zeros":
          s = r(e, 2);
      }
      return o.replace(n, s);
    },
    buildPdpBuyButtonPriceHtml(price, compareAtPrice) {
      const fmt =
        theme.config.money_format_no_trailing_zeros || theme.config.money.format;
      const formattedPrice = theme.utils.formatMoney(price, fmt);
      if (compareAtPrice > price) {
        const formattedCompare = theme.utils.formatMoney(compareAtPrice, fmt);
        return (
          '<span class="pdp-buy-form__prices">' +
          '<span class="pdp-buy-form__price">' +
          formattedPrice +
          "</span>" +
          '<s class="pdp-buy-form__compare-price">' +
          formattedCompare +
          "</s></span>"
        );
      }
      return '<span class="pdp-buy-form__price">' + formattedPrice + "</span>";
    },
    getPdpBuyButtonPrefix(el) {
      return el && el.closest(".pdp-buy-form-buttons.has-subscribe")
        ? "One Time Purchase"
        : "Buy Now";
    },
    buildPdpBuyButtonLabelHtml(variant, contextEl) {
      if (!variant) return "";
      return (
        '<span class="text-add-cart">' +
        theme.utils.getPdpBuyButtonPrefix(contextEl) +
        " - " +
        theme.utils.buildPdpBuyButtonPriceHtml(
          variant.price,
          variant.compare_at_price
        ) +
        "</span>"
      );
    },
    updateQuickAddBuyLabel(container, variant) {
      if (!container || !variant) return;
      const label = container.querySelector(".text-add-cart");
      if (!label) return;
      label.innerHTML =
        theme.utils.getPdpBuyButtonPrefix(container) +
        " - " +
        theme.utils.buildPdpBuyButtonPriceHtml(
          variant.price,
          variant.compare_at_price
        );
    },
    serializeForm: (e) => {
      var t = {},
        s = new FormData(e);
      for (const i of s.keys()) {
        var r = /(?:^(properties\[))(.*?)(?:\]$)/;
        r.test(i)
          ? ((t.properties = t.properties || {}),
            (t.properties[r.exec(i)[2]] = s.get(i)))
          : (t[i] = s.get(i));
      }
      return JSON.stringify(t);
    },
    debounce(t, s) {
      let r;
      return (...e) => {
        clearTimeout(r), (r = setTimeout(() => t.apply(this, e), s));
      };
    },
    getSiblings(e, t) {
      var s,
        r = [];
      let i;
      for (s of (i = t
        ? e.parentNode.querySelectorAll(":scope > " + t)
        : e.parentNode.children))
        s !== e && r.push(s);
      return r;
    },
    isNumeric(e) {
      return "string" == typeof e && !isNaN(e) && !isNaN(parseFloat(e));
    },
    inchesToCm(e) {
      return "number" != typeof e ? 0 : (2.54 * e).toFixed(2);
    },
    refreshElements(e, t, s) {
      e.forEach((e) => {
        const n = t.querySelectorAll(e);
        s.querySelectorAll(e).forEach((e, t) => {
          var s, r, i;
          n[t]
            ? null != e.getAttribute("js-accordion-item")
              ? ((s = e
                .querySelector("[js-accordion-header]")
                .getAttribute("aria-expanded")),
                (r = e
                  .querySelector("[js-accordion-content]")
                  .getAttribute("aria-hidden")),
                (i = n[t])
                  .querySelector("[js-accordion-header]")
                  .setAttribute("aria-expanded", s),
                i
                  .querySelector("[js-accordion-content]")
                  .setAttribute("aria-hidden", r),
                (e.innerHTML = i.innerHTML))
              : (e.innerHTML = n[t].innerHTML)
            : e.remove();
        });
      });
    },
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    },
    getCookie(e) {
      for (
        var t = e + "=",
        s = decodeURIComponent(document.cookie).split(";"),
        r = 0;
        r < s.length;
        r++
      ) {
        for (var i = s[r]; " " == i.charAt(0);) i = i.substring(1);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return "";
    },
    setCookie(e, t, s) {
      var r = new Date(),
        s =
          (r.setTime(r.getTime() + 24 * s * 60 * 60 * 1e3),
            "expires=" + r.toUTCString());
      document.cookie = e + "=" + t + ";" + s + ";path=/";
    },
  });
class FocusableWidget extends HTMLElement {
  constructor(e = {}) {
    if ((super(), !e.name))
      throw new Error(`Focusable Widget(${e.name}) must have a name`);
    if (!this.id) throw new Error(e.name + " must have an id");
    if (!e.background)
      throw new Error(`Focusable Widget(${e.name}) must have a background`);
    (this._clientConfig = e), this._init(e);
  }
  open = () => {
    if (!this._isOpen) return this._closeFocusableWidgets(), this.toggle();
  };
  close = () => {
    if (this._isOpen) return this.toggle();
  };
  toggle = () => (
    theme.utils.prepareTransition(this),
    this._toggleClasses(),
    this._toggleAccessibilityAttributes(),
    this._isOpen
      ? (theme.utils.a11y.removeTrapFocus(this),
        this._unbindEvents(),
        this._dispatchEvents(this._events.close, ["close"]))
      : (theme.utils.a11y.trapFocus(this),
        this._bindEvents(),
        this._dispatchEvents(this._events.open, ["open"])),
    (this._isOpen = !this._isOpen),
    this
  );
  reinitWidget = () => {
    this._init(this._clientConfig);
  };
  get isOpen() {
    return this._isOpen;
  }
  _init({
    name: e,
    background: t,
    widgetOpenClasses: s = [],
    bodyOpenClasses: r = [],
    attributes: i = {},
  }) {
    (this._name = e),
      (this._isOpen = !1),
      (this._selectors = {
        background: t,
        open: this.getAttribute("open"),
        close: this.getAttribute("close"),
      }),
      (this._nodes = {
        background: document.querySelector(this._selectors.background),
      }),
      (this._events = {
        open: ["focusable-widget:open", e + ":open", this.id + ":open"],
        close: ["focusable-widget:close", e + ":close", this.id + ":close"],
      }),
      (this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: {
          "data-focusable-widget": "true",
          "aria-hidden": "true",
          tabindex: 0,
          ...i,
        },
        widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
        bodyOpenClasses: [
          "js-focusable-widget-open",
          `js-${e}-open`,
          this.getAttribute("body-open-class"),
        ].concat(r),
      }),
      this._validateConfig(),
      this._addAccessibilityAttributes(),
      this._setupListeners();
  }
  _validateConfig() {
    if (
      ((this._config.open && this._config.open.length) ||
        console.warn(
          `WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`
        ),
        !this._config.close || !this._config.close.length)
    )
      throw new Error(
        `${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`
      );
  }
  _setupListeners() {
    this._config.open.forEach((e) =>
      e.addEventListener("click", this._open.bind(this))
    ),
      this._config.close.forEach((e) =>
        e.addEventListener("click", this._close.bind(this))
      ),
      this.addEventListener("click", (e) => e.stopPropagation());
  }
  _open(e) {
    e && (e.preventDefault(), e.stopPropagation()), this.open();
  }
  _close = (e) => {
    e && (e.preventDefault(), e.stopPropagation()), this.close();
  };
  _closeFocusableWidgets() {
    document
      .querySelectorAll("[data-focusable-widget].open")
      .forEach((e) => e.close());
  }
  _dispatchEvents(e, t) {
    e.forEach((e) => document.dispatchEvent(new CustomEvent(e))),
      t && t.length && t.forEach((e) => this.dispatchEvent(new CustomEvent(e)));
  }
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp),
      this._nodes.background.addEventListener("click", this._close),
      this._nodes.background.addEventListener("touchmove", this._onTouchMove);
  }
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp),
      this._nodes.background.removeEventListener("click", this._close),
      this._nodes.background.removeEventListener(
        "touchmove",
        this._onTouchMove
      );
  }
  _toggleClasses() {
    this._isOpen
      ? (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.remove(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.remove(e);
        }))
      : (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.add(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.add(e);
        }));
  }
  _toggleAccessibilityAttributes() {
    this._isOpen
      ? (this.setAttribute("aria-hidden", "true"),
        this.setAttribute("tabindex", "-1"),
        this._config.open.forEach((e) =>
          e.setAttribute("aria-expanded", "false")
        ),
        this._config.close.forEach((e) =>
          e.setAttribute("aria-expanded", "false")
        ))
      : (this.setAttribute("aria-hidden", "false"),
        this.setAttribute("tabindex", "0"),
        this._config.open.forEach((e) =>
          e.setAttribute("aria-expanded", "true")
        ),
        this._config.close.forEach((e) =>
          e.setAttribute("aria-expanded", "true")
        ));
  }
  _addAccessibilityAttributes() {
    var e = (e) => {
      e.setAttribute("tabindex", "0"),
        e.setAttribute("aria-expanded", "false"),
        e.setAttribute("aria-controls", this.id);
    };
    for (const t in this._config.attributes)
      this.setAttribute(t, this._config.attributes[t]);
    this._config.open.forEach(e), this._config.close.forEach(e);
  }
  _onKeyUp = (e) => {
    "ESCAPE" === e.code.toUpperCase() && this.close();
  };
  _onTouchMove = () => !1;
}
class Drawer extends FocusableWidget {
  constructor() {
    super({ name: "drawer", background: ".drawer-background" });
    var e = this.getAttribute("position");
    if (!e) throw new Error("drawer must have position attribute");
    (this._position = e),
      this._config.bodyOpenClasses.push(`js-drawer-${e}-open`),
      (this._clientConfig.bodyOpenClasses = [`js-drawer-${e}-open`]);
  }
  get position() {
    return this._position;
  }
}

class SizeDrawer extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        sizeChartTabTrigger: "[js-size-chart-tab-trigger]",
        sizeChartTabPanel: "[js-size-chart-tab-panel]",
        sizeChartHtml: "[js-size-chart-html]",
      });
  }
  
  connectedCallback() {
    super.connectedCallback?.(); // Call parent's connectedCallback if it exists
    this._initSizeChart();
  }

  _initSizeChart() {
    this._initSizeChartTabs();
    this._initSizeChartConversion();
  }

  _initSizeChartTabs() {
    const s = this.querySelectorAll(this._selectors.sizeChartTabTrigger),
      r = this.querySelectorAll(this._selectors.sizeChartTabPanel);
    
    function i(e) {
      var t = this.querySelector("#" + e.getAttribute("aria-controls"));
      s.forEach((e) => {
        e.setAttribute("aria-selected", "false"),
          e.setAttribute("tabindex", "-1"),
          e.classList.remove("bg-white");
      }),
        r.forEach((e) => {
          (e.hidden = !0), e.classList.add("hidden");
        }),
        e.setAttribute("aria-selected", "true"),
        e.setAttribute("tabindex", "0"),
        e.classList.add("bg-white"),
        (t.hidden = !1),
        t.classList.remove("hidden");
    }
    
    r.forEach((e) => {
      var t = e.querySelector(this._selectors.sizeChartHtml);
      e.innerHTML += t?.innerHTML || "";
    }),
      s.forEach((t) => {
        t.addEventListener("click", () => {
          i.call(this, t);
        }),
          t.addEventListener("keydown", (e) => {
            ("ArrowRight" !== e.key && "ArrowLeft" !== e.key) ||
              ((e = "ArrowRight" === e.key ? 1 : -1),
                (e =
                  s[
                  (Array.prototype.indexOf.call(s, t) + e + s.length) % s.length
                  ]).focus(),
                i.call(this, e));
          });
      });
  }

  _initSizeChartConversion() {
    var e = this.querySelector(
      this._selectors.sizeChartTabPanel + '[data-type="centimeter"]'
    );
    
    if (e) {
      // Get the table element
      var table = e.querySelector('table');
      if (!table) return;
      
      // Find the Inches column index (should be the first column with header "Inches")
      var inchesColumnIndex = -1;
      var headerRow = table.querySelector('thead tr, tr:first-child');
      if (headerRow) {
        var headers = headerRow.querySelectorAll('th, td');
        headers.forEach((header, index) => {
          if (header.textContent.trim().toUpperCase() === 'INCHES') {
            inchesColumnIndex = index;
          }
        });
      }
      
      // If Inches column found, convert only that column
      if (inchesColumnIndex >= 0) {
        var rows = table.querySelectorAll('tr');
        rows.forEach((row, rowIndex) => {
          var cells = row.querySelectorAll('td, th');
          if (cells[inchesColumnIndex] && rowIndex > 0) { // Skip header row
            var cell = cells[inchesColumnIndex];
            if (theme.utils.isNumeric(cell.innerHTML)) {
              cell.innerHTML = theme.utils.inchesToCm(parseFloat(cell.innerHTML));
            }
          }
        });
        
        // Update the header to show "CM" instead of "Inches"
        if (headerRow) {
          var headerCell = headerRow.querySelectorAll('th, td')[inchesColumnIndex];
          if (headerCell) {
            headerCell.innerHTML = 'CM';
          }
        }
      } else {
        // If no "Inches" header found, convert all numeric values
        [...e.querySelectorAll("td")]
          .concat([...e.querySelectorAll("th")])
          .forEach((cell) => {
            if (theme.utils.isNumeric(cell.innerHTML)) {
              cell.innerHTML = theme.utils.inchesToCm(parseFloat(cell.innerHTML));
            }
          });
      }
    }
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({
      name: "modal",
      background: ".modal-background",
      bodyOpenClasses: "js-modal-open",
    });
  }
}
class Accordion extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        accordion: "[js-accordion]",
        accordionItem: "[js-accordion-item]",
        accordionHeader: "[js-accordion-header]",
        accordionContent: "[js-accordion-content]",
      });
  }
  connectedCallback() {
    (this.buttons = this.querySelectorAll(this._selectors.accordionHeader)),
      this.buttons.forEach((e) => {
        e.addEventListener("click", this._toggleContent);
      }),
      (this.content = this.querySelectorAll(this._selectors.accordionContent));
  }
  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    var e = e.currentTarget,
      t = this.querySelector("#" + e.getAttribute("aria-controls")),
      s = theme.utils.getSiblings(
        e.parentElement,
        this._selectors.accordionItem
      );
    "false" == e.getAttribute("aria-expanded")
      ? (e.setAttribute("aria-expanded", !0),
        theme.utils.prepareTransition(t),
        this._expandSection(t),
        (this.dataset.manualCollapse &&
          "false" != this.dataset.manualCollapse) ||
        s.forEach((e) => {
          var t = e.querySelector(this._selectors.accordionHeader),
            e = e.querySelector("#" + t.getAttribute("aria-controls"));
          "true" == t.getAttribute("aria-expanded") &&
            (t.setAttribute("aria-expanded", !1), this._collapseSection(e));
        }))
      : (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
  };
  _collapseSection(e) {
    e.setAttribute("aria-hidden", !0), e.setAttribute("inert", !0);
  }
  _expandSection(e) {
    e.setAttribute("aria-hidden", !1), e.removeAttribute("inert");
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this._elements = {
      tabs: this.querySelectorAll("[js-tab]"),
      tabList: this.querySelectorAll("[js-tab-list]"),
      tabPanel: this.querySelectorAll("[js-tab-panel]"),
    }),
      this._tabEventListener(),
      this._tabListListener();
  }
  _tabEventListener = () => {
    var e = this._elements["tabs"];
    e.forEach((e) => e.addEventListener("click", this._showTabPanel));
  };
  _showTabPanel = (e) => {
    var t = this._elements["tabs"];
    for (let e = 0; e < t.length; e++)
      t[e].setAttribute("aria-selected", "false");
    e.target.setAttribute("aria-selected", "true");
    var e = e.target.getAttribute("aria-controls"),
      s = document.querySelectorAll("[role=tabpanel]");
    for (let e = 0; e < s.length; e++) s[e].setAttribute("aria-hidden", "true");
    document.getElementById(e).setAttribute("aria-hidden", "false");
  };
  _tabListListener = () => {
    var e = this._elements["tabList"];
    e.forEach((e) => e.addEventListener("keydown", this._tabListKeydown));
  };
  _tabListKeydown = (e) => {
    37 == e.keyCode &&
      ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      38 == e.keyCode &&
      ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      39 == e.keyCode &&
      ($("[aria-selected=true]").next().click().focus(), e.preventDefault()),
      40 == e.keyCode &&
      ($("[aria-selected=true]").next().click().focus(), e.preventDefault());
  };
}
class Carousel extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        carousel: "[js-carousel]",
        playBtn: "[js-play-btn]",
        pauseBtn: "[js-pause-btn]",
      }),
      (this.options = {
        loop: !0,
        slidesPerView: "auto",
        grabCursor: !0,
        centeredSlides: !1,
        navigation: !1,
        pagination: !1,
      });
  }
  connectedCallback() {
    let parsedOptions = {};
    if (this.dataset.options) {
      try {
        parsedOptions = JSON.parse(this.dataset.options);
      } catch (e) {
        console.warn("Invalid carousel data-options JSON:", this.dataset.options, e);
      }
    }
    (this.options = Object.assign(this.options, parsedOptions)),
      this._initCarousel(),
      (this.playBtn = this.querySelector(this.selectors.playBtn)),
      (this.pauseBtn = this.querySelector(this.selectors.pauseBtn)),
      this.playBtn &&
      this.pauseBtn &&
      (this.pauseBtn.addEventListener("click", this._handlePauseClick),
        this.playBtn.addEventListener("click", this._handlePlayClick));
  }
  _initCarousel() {
    const carouselEl = this.querySelector(this.selectors.carousel);
    if (!carouselEl) {
      console.warn("s-carousel: missing [js-carousel] element", this);
      return;
    }

    if (!carouselEl.id) {
      console.warn("s-carousel: [js-carousel] element is missing an id", this);
      return;
    }

    let e = "#" + carouselEl.id;

    if (this.options.navigation === true) {
      this.options.navigation = {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      };
    }
    // Render pagination bullets as real <button> elements so they're reachable and
    // operable by keyboard (Swiper's default <span> bullets are mouse/touch only).
    const bulletLabelTemplate = this.dataset.paginationBulletLabel || "Go to slide __INDEX__";
    const renderBullet = (index, className) => {
      const label = bulletLabelTemplate.replace(/__INDEX__/g, String(index + 1));
      return `<button type="button" class="${className}" aria-label="${label}"></button>`;
    };

    if (this.options.pagination === true) {
      const paginationEl = this.querySelector(".swiper-pagination");
      this.options.pagination = paginationEl
        ? { el: paginationEl, clickable: true, renderBullet }
        : false;
    } else if (this.options.pagination && typeof this.options.pagination === "object") {
      if (this.options.pagination.enabled === false) {
        this.options.pagination = false;
      } else if (!this.options.pagination.el) {
        const paginationEl = this.querySelector(".swiper-pagination");
        this.options.pagination = paginationEl
          ? {
              el: paginationEl,
              clickable: this.options.pagination.clickable !== false,
              renderBullet: this.options.pagination.renderBullet || renderBullet
            }
          : false;
      }
    }

    const initSwiper = (options) => {
      this.carousel = new Swiper(e, options);
      this.dispatchEvent(new CustomEvent("carousel:ready", { detail: { swiper: this.carousel }, bubbles: true }));
    };

    const initWithFallback = () => {
      try {
        initSwiper(this.options);
      } catch (error) {
        console.warn("s-carousel: Swiper init failed, retrying with safe options", error, this.options);
        try {
          initSwiper({
            ...this.options,
            loop: false,
            pagination: false,
            autoHeight: false,
            observer: false,
            observeParents: false,
            resizeObserver: false,
          });
        } catch (fallbackError) {
          console.error("s-carousel: Swiper fallback init failed", fallbackError);
        }
      }
    };

    void 0 !== this.dataset.init
      ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
        match: function () {
          initWithFallback.call(this);
        }.bind(this),
        unmatch: function () {
          this.carousel.el.classList.contains("swiper-initialized") &&
            this.carousel.destroy(!0, !0);
        }.bind(this),
      })
      : initWithFallback();
  }
  _handlePauseClick = (e) => {
    this.playBtn.classList.remove("hidden"),
      this.pauseBtn.classList.add("hidden"),
      this.carousel.autoplay.pause();
  };
  _handlePlayClick = (e) => {
    this.playBtn.classList.add("hidden"),
      this.pauseBtn.classList.remove("hidden"),
      this.carousel.autoplay.start();
  };
}

class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this._selectors = {
      header: "#shopify-section-header",
      container: "[js-header-container]",
      logo: "[js-logo]",
      mobileIconMenu: "[js-mobile-icon-menu]",
      childMenuTrigger: "[js-child-menu-trigger]",
      childMenuDrawer: "#childMenuDrawer",
      megaMenu: "[js-mega-menu]",
      membership: "[js-membership]",
      hoverZone: ".site-header__hover-zone"
    };
  }

  connectedCallback() {
    this.header = document.querySelector(this._selectors.header);
    this.container = this.querySelector(this._selectors.container);
    this.logo = this.querySelector(this._selectors.logo);
    this.mobileIconMenu = this.querySelector(this._selectors.mobileIconMenu);
    this.childMenuTriggers = this.querySelectorAll(this._selectors.childMenuTrigger);
    this.membership = this.querySelector(this._selectors.membership);
    this.hoverZone = this.querySelector(this._selectors.hoverZone);
    this._expandedHeaderEnabled = this.dataset.expandedHeader === "true";
    this._lastHeaderHeight = null;
    this._lastLogoScale = null;
    this._lastBgScale = null;
    this._headerSolid = null;
    this._scrollRafId = null;
    this._resizeRafId = null;
    this._observerRafId = null;
    this._setVariables();
    this._observeHeaderResize();
    this._setupExpandedHeaderInteraction();
    this._setListeners();
    this._scheduleHeaderHeightUpdates();
    this._watchWindowResize();
    this._watchDesktopBreakpoint();
  }

  disconnectedCallback() {
    document.removeEventListener("scroll", this._onScroll);
    if (this._headerResizeObserver) {
      this._headerResizeObserver.disconnect();
    }
    this.removeEventListener("megamenu:open", this._onMegaMenuOpen);
    this.removeEventListener("megamenu:close", this._onMegaMenuClose);
    window.removeEventListener("resize", this._onWindowResize);
    this._desktopMql?.removeEventListener("change", this._onDesktopBreakpointChange);
    cancelAnimationFrame(this._scrollRafId);
    cancelAnimationFrame(this._resizeRafId);
    cancelAnimationFrame(this._observerRafId);
  }

  _observeHeaderResize() {
    if (!this.header || typeof ResizeObserver === "undefined") return;

    // Coalesced to one write per frame — the header resizes on every frame of
    // the expand/compact transition.
    this._headerResizeObserver = new ResizeObserver(() => {
      if (this._observerRafId) return;
      this._observerRafId = requestAnimationFrame(() => {
        this._observerRafId = null;
        this._setVariables();
      });
    });
    this._headerResizeObserver.observe(this.header);
  }

  _scheduleHeaderHeightUpdates() {
    requestAnimationFrame(() => this._setVariables());
    window.addEventListener("load", this._setVariables, { once: true });

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this._setVariables());
    }

    if (this._expandedHeaderEnabled) {
      document.addEventListener("scroll", this._onScroll, { passive: true });
      this._onScroll();
    } else if (this.dataset.transparent === "true" && this.dataset.stickyHeader === "true") {
      document.addEventListener("scroll", this._onScroll, { passive: true });
      this._onScroll();
    }
  }

  // Scroll and resize both land here; coalesced to one pass per frame so a fast
  // scroll can't queue up dozens of layout reads while the header is animating.
  _onScroll = () => {
    if (this._scrollRafId) return;
    this._scrollRafId = requestAnimationFrame(() => {
      this._scrollRafId = null;
      if (this._expandedHeaderEnabled) {
        this._updateExpandedHeaderLayout();
      }
      if (this.dataset.transparent === "true" && this.dataset.stickyHeader === "true") {
        this._headerOnScroll();
      }
    });
  };

  // Desktop header starts at pdplayout (1050px); keep in sync with header.css
  // and the tablet override in sections/header.liquid.
  static DESKTOP_QUERY = "(min-width: 1050px)";

  _isExpandedDesktop() {
    return window.matchMedia(SiteHeader.DESKTOP_QUERY).matches;
  }

  // The mobile drawer has no desktop layout, so close it if the window is
  // resized past the breakpoint while it's open.
  _watchDesktopBreakpoint() {
    this._desktopMql = window.matchMedia(SiteHeader.DESKTOP_QUERY);
    this._desktopMql.addEventListener("change", this._onDesktopBreakpointChange);
  }

  _onDesktopBreakpointChange = (event) => {
    if (!event.matches) return;
    document.getElementById("MobileNavDrawer")?.close?.();
  };

  _isAtTop() {
    return window.scrollY <= 20;
  }

  _isAnyMegaMenuOpen() {
    return document.querySelector("s-drawer-megamenu.open") !== null;
  }

  /*
   * The expanded/compact state is a plain CSS concern:
   *   expanded = .site-header--at-top AND not :hover/:focus-within AND no megamenu
   * so the only thing JS owns here is the scroll position and the megamenu flag.
   */
  _updateExpandedHeaderLayout() {
    if (!this._expandedHeaderEnabled) return;

    const atTop = this._isAtTop();
    if (this.classList.contains("site-header--at-top") !== atTop) {
      this.classList.toggle("site-header--at-top", atTop);
    }
    this._setVariables();
  }

  /*
   * The compact logo and the compact background panel are both the expanded
   * thing scaled down, so neither has to animate a layout property. The
   * expanded sizes depend on the viewport (the logo is min(58vw, 590px)), so
   * the two ratios are recalculated here on load and on resize.
   */
  _setHeaderScales = () => {
    if (!this._expandedHeaderEnabled) return;

    const styles = getComputedStyle(this);
    const cssLength = (name) => parseFloat(styles.getPropertyValue(name));

    // offsetWidth ignores the scale transform, so this is the untransformed width
    const expandedLogoWidth = this.logo?.offsetWidth;
    const compactLogoWidth = cssLength("--header-logo-width-compact");
    this._applyScale("--header-logo-scale-compact", compactLogoWidth / expandedLogoWidth, "_lastLogoScale");

    // the hover zone is never transformed, so its rect is the exact expanded height
    const expandedHeaderHeight = this.hoverZone?.getBoundingClientRect().height;
    const compactHeaderHeight =
      cssLength("--header-nav-row-padding-top") +
      cssLength("--header-nav-row-height") +
      cssLength("--header-compact-padding-bottom");
    this._applyScale("--header-bg-scale-compact", compactHeaderHeight / expandedHeaderHeight, "_lastBgScale");
  };

  _applyScale(property, scale, cacheKey) {
    if (!Number.isFinite(scale) || scale <= 0 || scale === this[cacheKey]) return;

    this[cacheKey] = scale;
    this.style.setProperty(property, scale.toFixed(5));
  }

  _setupExpandedHeaderInteraction() {
    if (!this._expandedHeaderEnabled) return;

    this._onMegaMenuOpen = () => {
      this.classList.toggle("site-header--megamenu-open", this._isExpandedDesktop());
      this._setVariables();
    };

    // Switching between menus closes one before opening the next — defer a frame
    // so the header doesn't flash back to expanded in between.
    this._onMegaMenuClose = () => {
      requestAnimationFrame(() => {
        this.classList.toggle(
          "site-header--megamenu-open",
          this._isExpandedDesktop() && this._isAnyMegaMenuOpen()
        );
        this._setVariables();
      });
    };

    this.addEventListener("megamenu:open", this._onMegaMenuOpen);
    this.addEventListener("megamenu:close", this._onMegaMenuClose);

    requestAnimationFrame(this._setHeaderScales);
  };

  _setListeners() {
    const triggers = document.querySelectorAll('[data-drawer-id]');

    triggers.forEach((trigger) => {
      const drawerId = trigger.dataset.drawerId;
      const drawer = document.getElementById(drawerId);
      if (!drawer) return;

      const isMegaMenu = drawer.tagName === "S-DRAWER-MEGAMENU";

      trigger.addEventListener("click", (e) => {
        this._childMenuTriggerOnClick(e, trigger, drawer);
      });

      trigger.addEventListener("mouseenter", (e) => {
        this._childMenuTriggerOnClick(e, trigger, drawer);
      });

      trigger.addEventListener("focus", (e) => {
        this._childMenuTriggerOnClick(e, trigger, drawer);
      });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this._childMenuTriggerOnClick(e, trigger, drawer);
        }
      });

      drawer.addEventListener("close", () => {
        this._deactivateTrigger(trigger, drawer);
      });

      if (!isMegaMenu) {
        drawer.addEventListener("mouseleave", () => {
          this._deactivateTrigger(trigger, drawer);
          drawer.close();
        });
      }

    });
  }

  _watchWindowResize() {
    window.addEventListener("resize", this._onWindowResize);
  }

  _onWindowResize = () => {
    if (this._resizeRafId) return;
    this._resizeRafId = requestAnimationFrame(() => {
      this._resizeRafId = null;
      this._setHeaderScales();
      this._setVariables();
      if (this._expandedHeaderEnabled) {
        this._updateExpandedHeaderLayout();
      }
    });
  };

  // Only written when it actually changes — every write invalidates style for
  // each rule that reads var(--header-height).
  _setVariables = () => {
    if (!this.header || typeof this.header.clientHeight !== "number") return;

    const height = this.header.clientHeight;
    if (height === this._lastHeaderHeight) return;

    this._lastHeaderHeight = height;
    document.documentElement.style.setProperty("--header-height", height + "px");
  };

  _headerOnScroll = () => {
    const hero = document.querySelector("hero-logo");
    const headerHeight = this.header ? this.header.clientHeight : 0;
    const scrollPastHero = hero && window.scrollY > hero.getBoundingClientRect().bottom - 0.01 * window.innerHeight;
    const scrollPastPastHome = window.scrollY > Math.max(headerHeight, 50);
    const isSolid = Boolean(scrollPastHero || scrollPastPastHome);

    if (isSolid === this._headerSolid) return;
    this._headerSolid = isSolid;

    if (isSolid) {
      this.container.classList.add("!bg-white", "!text-black", "back-white");
      this.logo.classList.add("!text-black");
      this.mobileIconMenu.classList.add("!text-black");
      this.membership.classList.add("text-green");
    } else {
      this.container.classList.remove("!bg-white", "!text-black", "back-white");
      this.logo.classList.remove("!text-black");
      this.mobileIconMenu.classList.remove("!text-black");
      this.membership.classList.remove("text-green");
    }
  };

  _deactivateTrigger(trigger, drawer) {
    trigger.dataset.active = "false";
    trigger.style.textDecoration = "";
    const activeMenu = drawer.querySelector(`${this._selectors.megaMenu}[data-active="true"]`);
    if (activeMenu) activeMenu.dataset.active = "false";
  }

  _deactivateAll() {
    this.childMenuTriggers.forEach((trigger) => {
      trigger.dataset.active = "false";
      trigger.style.textDecoration = "";
      const drawerId = trigger.dataset.drawerId;
      const drawer = document.getElementById(drawerId);
      if (drawer) {
        const menus = drawer.querySelectorAll(this._selectors.megaMenu);
        menus.forEach((menu) => (menu.dataset.active = "false"));
        drawer.close();
      }
    });
  }

  _childMenuTriggerOnClick(e, trigger, drawer) {
    e.stopPropagation();
    const isActive = trigger.dataset.active === "true";
    const menuHandle = trigger.dataset.handle;
    const menuToShow = drawer.querySelector(`${this._selectors.megaMenu}[data-handle="${menuHandle}"]`);

    if (isActive) {
      this._deactivateTrigger(trigger, drawer);
      drawer.close();
    } else {
      this._deactivateAll();
      trigger.dataset.active = "true";
      if (menuToShow) menuToShow.dataset.active = "true";
      drawer.open();

      requestAnimationFrame(() => {
        const wrapper = drawer.querySelector('#product-panel-wrapper');
        const activeBlock = wrapper?.querySelector('.child-menu-products.opacity-100.visible');
        if (wrapper && activeBlock) {
          const newHeight = activeBlock.offsetHeight + 80;
          wrapper.style.setProperty('--dynamic-height', newHeight + 'px');
        }
      });
    }
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      e.preventDefault();

      console.log("🧹 CartRemoveButton clicked");

      const cartElement = this.closest("cart-items") || this.closest("cart-drawer-items");
      const cartItem = this.closest(".cart-item");

      if (cartItem.dataset.bundleId) {
        const bundleId = cartItem.dataset.bundleId;
        const allItems = Array.from(cartElement.querySelectorAll(".cart-item"));
        const bundleItems = allItems.filter((item) => item.dataset.bundleId == bundleId);

        cartElement.updateBundleQuantity(bundleItems);
      } else {
        cartElement.updateQuantity(this.dataset.index, 0);
      }


      setTimeout(() => {
        updateMultipleCartBubbles();
      }, 500);
    });
  }
}
class CartItems extends HTMLElement {
  constructor() {
    super();
    var e = theme.utils.debounce((e) => {
      this.onChange(e);
    }, 300);
    this.addEventListener("change", e.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.cart = document.querySelector("cart-drawer")),
      (this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(
        window.PUB_SUB_EVENTS.cartUpdate,
        (e) => {
          "cart-items" !== e.source && this.onCartUpdate();
        }
      )),
      this.handleDrawerOpenClose();
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
      this.cartDrawer.removeEventListener("open", this.drawerOpen),
      this.cartDrawer.removeEventListener("close", this.drawerClose);
  }
  drawerOpen = () => {
    this.main.querySelectorAll(".shopify-section").forEach((e) => {
      e.setAttribute("inert", "true");
    }),
      this.footer.setAttribute("inert", "");
  };
  drawerClose = () => {
    this.main.querySelectorAll(".shopify-section").forEach((e) => {
      e.removeAttribute("inert");
    }),
      this.footer.removeAttribute("inert");
  };
  handleDrawerOpenClose = () => {
    (this.main = document.querySelector("#MainContent")),
      (this.footer = document.querySelector("#shopify-section-footer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      this.cartDrawer.addEventListener("open", this.drawerOpen),
      this.cartDrawer.addEventListener("close", this.drawerClose);
  };
  onChange(e) {
    this.updateQuantity(
      e.target.dataset.index,
      e.target.value,
      document.activeElement.getAttribute("name"),
    );
  }
  onCartUpdate() {
    fetch(routes.cart_url + "?section_id=cart__main")
      .then((e) => e.text())
      .then((e) => {
        e = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("cart-items");
        this.innerHTML = e.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "CartPage-CartItems",
        section: document.getElementById("CartPage-CartItems").dataset.id,
        selector: "[js-cart-page-contents]",
      },
    ];
  }
  updateQuantity(o, e, a) {
    this.enableLoading(o);
    e = JSON.stringify({
      line: o,
      quantity: e,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: e,
    })
      .then((e) => e.text())
      .then((t) => {
        const s = JSON.parse(t);
        var t =
          document.getElementById("Quantity-" + o) ||
          document.getElementById("Drawer-quantity-" + o),
          r = document.querySelectorAll("[js-cart-item]"),
          i = document.querySelector("[js-sr-item-count]");
        let e = "";
        if (
          (0 < s.items_added.length
            ? (e = "Item Added. ")
            : 0 < s.items_removed.length && (e = "Item Removed. "),
            (i.innerHTML = `<p>${e}Shopping Bag Items ${s.item_count
              }. Total ${theme.utils.formatMoney(
                s.items_subtotal_price,
                theme.config.money.format
              )}</p>`),
            s.errors)
        )
          (t.value = t.getAttribute("value")),
            this.updateLiveRegions(o, s.errors);
        else {
          var i = document.querySelector("cart-drawer"),
            n =
              (this.getSectionsToRender().forEach((e) => {
                (
                  document.getElementById(e.id).querySelector(e.selector) ||
                  document.getElementById(e.id)
                ).innerHTML = this.getSectionInnerHTML(
                  s.sections[e.section],
                  e.selector
                );
              }),
                s.items[o - 1] ? s.items[o - 1].quantity : void 0);
          let e = "";
          r.length === s.items.length &&
            n !== parseInt(t.value) &&
            (e =
              void 0 === n
                ? "There was an error while updating your cart. Please try again."
                : `You can only add ${n} of this item to your cart.`),
            this.updateLiveRegions(o, e);
          r =
            document.getElementById("CartItem-" + o) ||
            document.getElementById("CartDrawer-Item-" + o);
          r && r.querySelector(`[name="${a}"]`)
            ? i
              ? theme.utils.a11y.trapFocus(i, r.querySelector(`[name="${a}"]`))
              : r.querySelector(`[name="${a}"]`).focus()
            : 0 === s.item_count && i
              ? theme.utils.a11y.trapFocus(i.querySelector("[js-empty-cart]"))
              : document.querySelector("[js-cart-item]") &&
              i &&
              theme.utils.a11y.trapFocus(
                i,
                document.querySelector("[js-cart-item-image]")
              ),
            theme.utils.subscriptions.publish(
              window.PUB_SUB_EVENTS.cartUpdate,
              { source: "cart-items" }
            );
        }
      })
      .catch((e) => {
        console.log(e),
          this.querySelectorAll(".loading-overlay").forEach((e) =>
            e.classList.add("hidden")
          ),
          ((
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors")
          ).textContent =
            "There was an error while updating your cart. Please try again.");
      })
      .finally(() => {
        this.disableLoading(o);
      });
  }
  updateBundleQuantity(e) {
    let t = {};
    e.forEach((e) => {
      e.dataset.key;
      t[e.dataset.key] = 0;
    }),
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: t,
          sections: this.getSectionsToRender().map((e) => e.section),
          sections_url: window.location.pathname,
        }),
      })
        .then((e) => e.json())
        .then((e) => {
          const t = e;
          document.querySelectorAll("[js-cart-item]");
          (document.querySelector(
            "[js-sr-item-count]"
          ).innerHTML = `<p>Shopping Bag Items ${t.item_count}</p>`),
            t.errors
              ? this.updateLiveRegions(line, t.errors)
              : (document.querySelector("cart-drawer"),
                this.getSectionsToRender().forEach((e) => {
                  (
                    document.getElementById(e.id).querySelector(e.selector) ||
                    document.getElementById(e.id)
                  ).innerHTML = this.getSectionInnerHTML(
                    t.sections[e.section],
                    e.selector
                  );
                }));
        })
        .catch((e) => {
          console.log(e),
            this.querySelectorAll(".loading-overlay").forEach((e) =>
              e.classList.add("hidden")
            ),
            ((
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors")
            ).textContent =
              "There was an error while updating your cart. Please try again.");
        });
  }
  updateLiveRegions(e, t) {
    e =
      document.getElementById("Line-item-error-" + e) ||
      document.getElementById("CartDrawer-LineItemError-" + e);
    e && (e.classList.add("pt-8"), (e.innerHTML = t));
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  enableLoading(e) {
    (
      document.getElementById("CartPage-CartItems") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.add("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach((e) => e.setAttribute("loading", "")),
      document.activeElement.blur();
  }
  disableLoading(e) {
    (
      document.getElementById("CartPage-CartItems") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.remove("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach((e) => e.removeAttribute("loading"));
  }
}
class CartNote extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener(
        "change",
        theme.utils.debounce((e) => {
          e = JSON.stringify({ note: e.target.value });
          fetch("" + routes.cart_update_url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: e,
          });
        }, 500)
      );
  }
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  renderContents(t) {
    this.productId = t.id;

    this.getSectionsToRender().forEach((e) => {
      const container = e.selector
        ? document.querySelector(e.selector)
        : document.getElementById(e.id);

      if (container) {
        container.innerHTML = this.getSectionInnerHTML(
          t.sections[e.id],
          e.selector
        );
      } else {
        console.warn(`[CART] content not found '${e.id || e.selector}'`);
      }
    });
  }
  updateLiveItemCount(e) {
    var e = new DOMParser()
      .parseFromString(e, "text/html")
      .querySelector("[js-item-count]"),
      t = document.querySelector("[js-sr-item-count]"),
      s = document.querySelector("[js-cart-total]");
    e &&
      (t.innerHTML = `<p>Item Added. Shopping Bag Items ${e.textContent}. Total ${s.textContent}</p>`);
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  getSectionsToRender() {
    return [{ id: "cart", selector: "#cart" }, { id: "cart-count" }];
  }
  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "cart", section: "cart", selector: "[js-cart-drawer-contents]" },
      { id: "cart-count", section: "cart-count", selector: ".shopify-section" },
    ];
  }
}
class CartUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = { quickAddSingleVariant: "[js-quick-add-single]" });
  }
  connectedCallback() {
    (this._quickAddSingleVariant = this.querySelector(
      this.selectors.quickAddSingleVariant
    )),
      (this.cart = document.querySelector("cart-drawer")),
      this._initQuickAdd();
    updateMultipleCartBubbles();

  }
  _initQuickAdd() {
    null != this._quickAddSingleVariant &&
      this._quickAddSingleVariant.addEventListener(
        "click",
        this._submitSingle.bind(this),
        updateMultipleCartBubbles()
      );
  }
  _submitSingle(e) {
    e.preventDefault();
    (e = e.currentTarget.dataset.variantId),
      this.cart.setActiveElement(document.activeElement),
      (e = {
        items: [{ id: e, quantity: 1 }],
        sections: this.getSectionsToRender().map((e) => e.section),
      });
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(e),
    })
      .then((e) => e.json())
      .then((e) => {
        if (!e.status)
          return (
            this.cart.renderContents(e),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          );
        this._handleErrorMessage(e.description);
      })
      .then((e) => e.text())
      .then((e) => {
        this.cart.updateLiveItemCount(e);
        updateMultipleCartBubbles();
      })
      .catch((e) => {
        console.error("Error:", e);
      });
  }
  getSectionsToRender() {
    return [
      { id: "cart", section: "cart", selector: "[js-cart-drawer-contents]" },
      { id: "cart-count", section: "cart-count", selector: ".shopify-section" },
    ];
  }
}
class ProductOptions extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        singleOptionSelector: "[js-product-option-selector]",
      }),
      (this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      });
  }
  connectedCallback() {
    var e;
    (this._handle = this.dataset.productHandle),
      (this._masterSelect = document.getElementById(
        this.dataset.masterSelectId
      )),
      (this._checkAvailableOptions = !this.hasAttribute(
        "data-disable-option-binding"
      )),
      (this._optionSelectors = [
        ...this.querySelectorAll(this._selectors.singleOptionSelector),
      ]),
      this._checkAvailableOptions &&
      ((this._availableValues = {}),
        (this._lastSelectedOption = null),
        (this._option1Values = this._option2Values = null)),
      this.dataset.product &&
      (e = document.getElementById(this.dataset.product)) &&
      (this._product = JSON.parse(e.innerHTML)),
      this._product &&
      ((this._currentVariant = this._getVariantFromOptions()),
        this._checkAvailableOptions) &&
      this._setupOptionsAvailability(this._product),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(e) {
    (this._product = e), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((e) =>
      e.addEventListener("change", this._handleOptionChange)
    );
  }
  _getVariantFromOptions() {
    if (this._product) {
      const s = this._getCurrentOptions();
      var e = this._product["variants"];
      return e.find((t) =>
        s.every(
          (e) =>
            e.value ===
            t[e.index]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
        )
      );
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((e) => {
        var t = e.getAttribute("type"),
          s = {};
        return (
          (("radio" !== t && "checkbox" !== t) || !!e.checked) &&
          ((s.value = e.value), (s.index = e.dataset.index), s)
        );
      })
      .filter((e) => e);
  }
  _setupOptionsAvailability(e) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      e.variants.forEach((e) => {
        var { option1: e, option2: t } = e;
        e &&
          this._option1Values.add(
            e
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
          ),
          t &&
          this._option2Values.add(
            t
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
          );
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      this._optionSelectors.forEach((e) => {
        null == this._lastSelectedOption &&
          e.checked &&
          (this._lastSelectedOption = { key: e.dataset.index, value: e.value });
      }),
      (this._availableValues = this._getAvailableValues(
        this._product,
        this._lastSelectedOption
      )),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = (t) => {
    this._product
      ? this._updateVariant(t)
      : this._fetchProduct(this._handle)
        .then((e) => {
          (this._product = e),
            this._checkAvailableOptions &&
            this._setupOptionsAvailability(this._product),
            this._updateVariant(t);
        })
        .catch((e) => console.log(e));
  };
  _updateVariant(e) {
    this._lastSelectedOption = {
      key: e.target.dataset.index,
      value: e.target.value,
    };
    var t,
      s,
      e = this._getVariantFromOptions();
    this.dispatchEvent(
      new CustomEvent(this._events.change, {
        detail: { variant: e, priceChange: this._hasPriceChanged(e) },
        bubbles: !0,
      })
    ),
      this._checkAvailableOptions &&
      ((t = this._getAvailableValues(
        this._product,
        this._lastSelectedOption
      )),
        (s = this._getDifference(this._availableValues, t)),
        this._refreshValuesUI(s),
        (this._availableValues = t)),
      this.hasAttribute("data-enable-history-state") &&
      this._updateHistoryState(e),
      this._masterSelect && this._updateMasterSelect(e),
      (this._currentVariant = e);
  }
  _hasPriceChanged(e) {
    return !(
      !e ||
      !this._currentVariant ||
      (e.price === this._currentVariant.price &&
        e.compare_at_price === this._currentVariant.compare_at_price)
    );
  }
  _getAvailableValues(s, r) {
    if (r) {
      const i = {};
      var e = ["option1", "option2"],
        t = { option1: this._option1Values, option2: this._option2Values };
      const n = e.find((e) => e !== r.key);
      return (
        t[n].forEach((t) => {
          var e = s.variants.findIndex(
            (e) =>
              e[r.key]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === r.value &&
              e[n]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === t &&
              e.available
          );
          i[t] = 0 <= e;
        }),
        i
      );
    }
    return s.variants.reduce((e, t) => {
      var { option1: t, option2: s } = t;
      return t && (e[t] = !0), s && (e[s] = !0), e;
    }, {});
  }
  _refreshValuesUI(e) {
    for (const s in e) {
      var t = this.querySelector(`[value="${s}"]`);
      t && (t.disabled = !e[s]);
    }
  }
  _updateHistoryState(e) {
    history.replaceState &&
      e &&
      ((e =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        e.id),
        window.history.replaceState({ path: e }, "", e));
  }
  _updateMasterSelect(e) {
    e && (this._masterSelect.value = e.id);
  }
  async _fetchProduct(e) {
    this.dispatchEvent(
      new CustomEvent(this._events.fetchBefore, { bubbles: !0 })
    );
    try {
      var t = await (await fetch(`/products/${e}.js`)).json();
      return (
        this.dispatchEvent(
          new CustomEvent(this._events.fetchAfter, { bubbles: !0 })
        ),
        t
      );
    } catch (e) {
      this.dispatchEvent(
        new CustomEvent(this._events.fetchError, {
          details: { error: e },
          bubbles: !0,
        })
      );
    }
  }
  _getDifference(e, t) {
    var s = {};
    if (e || t) {
      if (!e) return t;
      if (!t) return e;
      for (const r in t) t[r] !== e[r] && (s[r] = t[r]);
    }
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((e) =>
      e.removeEventListener("change", this._handleOptionChange)
    );
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    "plus" === e.currentTarget.name
      ? this.input.stepUp()
      : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    updateMultipleCartBubbles();
  }
}
class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    var e = document.createElement("template");
    (e.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
        visibility: hidden;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `),
      this.attachShadow({ mode: "open" }),
      this.shadowRoot.appendChild(e.content.cloneNode(!0));
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.clear = this.querySelector('button[type="reset"]');
    this.predictiveSearchResults = this.querySelector("[js-predictive-search]");
    this.predictiveSearchNumber = this.querySelector("[js-predictive-search-number]");
    this.navmobile = document.querySelector(".mobile-nav__nav");

    this.input.addEventListener(
      "input",
      theme.utils
        .debounce((e) => {
          this.onChange(e);
        }, 300)
        .bind(this)
    );

    this.clear.addEventListener("click", this.onClear.bind(this));

    document.addEventListener("SearchDrawer:open", () => {
      const input = this.querySelector("[js-search-input]");
      if (input) input.focus();
    });
  }

  onClear() {
    this.clear.style.display = "none";
    this.close();
    const input = this.querySelector("[js-search-input]");
    if (input) input.focus();
  }

  onChange() {
    const query = this.input.value.trim();
    if (query.length) {
      this.clear.style.display = "flex";
      this.predictiveSearchNumber.style.display = "flex";
      this.input.classList.remove("opacity-60");
      this.getSearchResults(query);
      this.getSearchCount(query);
    } else {
      this.clear.style.display = "none";
      this.predictiveSearchNumber.style.display = "none";
      this.input.classList.add("opacity-60");
      this.close();
    }
  }

  getSearchResults(query) {
    fetch(
      routes.predictive_search_url +
      `?q=${query}&resources[type]=product&resources[limit]=20&section_id=predictive-search`
    )
      .then((res) => {
        if (res.ok) return res.text();
        throw new Error(res.status);
      })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const section = parsed.querySelector("#shopify-section-predictive-search");
        if (section) {
          this.predictiveSearchResults.innerHTML = section.innerHTML;
          this.open();
        }
      })
      .catch((err) => {
        console.error("Error fetching predictive search results:", err);
        this.close();
      });
  }

  getSearchCount(query) {
    fetch(
      routes.predictive_search_url +
      `?q=${query}&resources[type]=product&resources[limit]=20&section_id=predictive-search--resources-number`
    )
      .then((res) => {
        if (res.ok) return res.text();
        throw new Error(res.status);
      })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const section = parsed.querySelector("#shopify-section-predictive-search--resources-number");
        if (section && this.predictiveSearchNumber) {
          this.predictiveSearchNumber.innerHTML = section.innerHTML;
        }
      })
      .catch((err) => {
        console.error("Error fetching search count:", err);
      });
  }

  open() {
  clearTimeout(this.closeTimer);

  // chiudi gli altri
  MegaMenu.all.forEach(menu => {
    if (menu !== this) menu.forceClose();
  });

  this.classList.add("open");
  this.setAttribute("data-open", "true");

  this.triggers.forEach(t => {
    t.setAttribute("aria-expanded", "true");
    t.setAttribute("data-active", "true");   // 🔥 aggiunto
  });

  document.body.classList.add("js-drawer-open", "js-drawer-child-menu-open");
}

forceClose() {
  this.classList.remove("open");
  this.removeAttribute("data-open");

  this.triggers.forEach(t => {
    t.setAttribute("aria-expanded", "false");
    t.setAttribute("data-active", "false");  // 🔥 aggiunto
  });

  // se nessun altro menu è aperto
  const anyOpen = Array.from(MegaMenu.all).some(menu => menu.classList.contains("open"));
  if (!anyOpen) {
    document.body.classList.remove("js-drawer-open", "js-drawer-child-menu-open");
  }
}

  close() {
    this.predictiveSearchResults.style.display = "none";
    if (this.navmobile) {
      this.navmobile.style.display = "block";
    }
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        container: "filter-sort",
        form: "[js-filter-form]",
        filter: "[js-filter]",
        clearAll: "[js-clear-all]",
        loader: "loading-spinner",
        countButton: "[js-count-button]",
      }),
      (this._events = { change: "filter:change" }),
      (this._cache = []),
      (this._debouncedOnSubmit = theme.utils.debounce((e) => {
        this._onSubmitHandler(e);
      }, 500));
  }
  connectedCallback() {
    (this._form = this.querySelector(this._selectors.form)),
      (this._clearAll = this.querySelector(this._selectors.clearAll)),
      (this._loader = this.querySelector(this._selectors.loader)),
      (this._countButton = document.querySelector(this._selectors.countButton)),
      this._setListeners();
  }
  _setListeners() {
    window.addEventListener("popstate", this._onHistoryChange),
      this._form.addEventListener("input", this._debouncedOnSubmit),
      this._clearAll.addEventListener("click", this._onClearAllHandler),
      document.addEventListener("filter:clearAll", this._onClearAllHandler);
  }
  _renderComponent(e) {
    e = e.querySelector(this._selectors.container);
    theme.utils.refreshElements([this._selectors.filter], e, this);
  }
  _onSubmitHandler = (e) => {
    e.preventDefault();
    (e = new FormData(this._form)), (e = new URLSearchParams(e).toString());
    this._propagateChange(e);
  };
  _onClearAllHandler = (e) => {
    e.preventDefault();
    let t = "";
    e = document.querySelector("s-collection-grid[js-search-page]");
    e && e.dataset.term && (t = "q=" + e.dataset.term),
      this._propagateChange(t);
  };
  _onHistoryChange = (e) => {
    e = e.state ? e.state.searchParams : FilterSort.searchParamsInitial;
    e !== FilterSort.searchParamsPrev &&
      (this._propagateChange(e, !1), (this._onSubmitHandlerEvent = null));
  };
  _updateProductCount(parsedHTML) {
    if (!this._countButton) return;
    let productItems = parsedHTML.querySelectorAll('#gridsearch product-card');
    let count = productItems.length;

    // Update button text
    this._countButton.textContent = `View ${count} products`;
    this._countButton.classList.remove('hidden');
    this._clearAll.classList.remove('hidden');
  }
  async _propagateChange(e, t = !0) {
    this._loader.setAttribute("loading", "");
    const s = window.location.pathname + "?" + e;
    var r = (e) => e.url === s,
      r = this._cache.some(r)
        ? this._markupFromCache(r)
        : await this._markupFromFetch(s);
    document.dispatchEvent(
      new CustomEvent("filter:change", { detail: { parsedHTML: r } })
    );

    this._renderComponent(r);

    this._updateProductCount(r);

    if (typeof window.initSwitcher === 'function') {
      window.initSwitcher();
    }

    this.querySelectorAll("s-accordion").forEach((e) => {
      e.connectedCallback();
    }),
      t &&
      history.pushState(
        { searchParams: e },
        "",
        "" + window.location.pathname + (e && "?".concat(e))
      ),
      this._loader.removeAttribute("loading", "");
  }
  _markupFromCache(e) {
    e = this._cache.find(e).html;
    return new DOMParser().parseFromString(e, "text/html");
  }
  _markupFromFetch(s) {
    let r = this._cache;
    return fetch(s)
      .then((e) => e.text())
      .then((e) => {
        var t = new DOMParser().parseFromString(e, "text/html");
        return (r = [...r, { html: e, url: s }]), t;
      });
  }
}
(FilterSort.searchParamsInitial = window.location.search.slice(1)),
  (FilterSort.searchParamsPrev = window.location.search.slice(1));
class ActiveFilters extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { remove: "[js-remove]", clearAll: "[js-clear-all]" }),
      (this._refresh = ["[js-active-filter]"]);
  }
  connectedCallback() {
    document.addEventListener("filter:change", this._handleFilterChange),
      this._setListeners();
  }
  _setListeners() {
    var e = this.querySelector(this._selectors.clearAll);
    e && e.addEventListener("click", this._triggerClearAll),
      this.querySelectorAll(this._selectors.remove).forEach((e) =>
        e.addEventListener("click", this._handleRemove)
      );
  }
  _handleRemove = (e) => {
    e.preventDefault();
    var { name: e, value: t } = e.currentTarget.dataset,
      e = document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);
    e && e.click();
  };
  _handleFilterChange = (e) => {
    (e = e.detail.parsedHTML), (e = e.querySelector("active-filters"));
    (this.innerHTML = e.innerHTML), this._setListeners();
  };
  _triggerClearAll = (e) => {
    e.preventDefault(),
      e.stopImmediatePropagation(),
      document.dispatchEvent(new CustomEvent("filter:clearAll"));
  };
}
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    var e = this.querySelectorAll("input"),
      t = e[0],
      e = e[1];
    e.value && t.setAttribute("max", e.value),
      t.value && e.setAttribute("min", t.value),
      "" === t.value && e.setAttribute("min", 0),
      "" === e.value && t.setAttribute("max", e.getAttribute("max"));
  }
  adjustToValidValues(e) {
    var t = Number(e.value),
      s = Number(e.getAttribute("min")),
      r = Number(e.getAttribute("max"));
    t < s && (e.value = s), r < t && (e.value = r);
  }
}


class ProductCard extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        selectAddToCart: "[js-select-add-to-cart]",
        quickAdd: "[js-quick-add]",
        quickAddTrigger: "[js-quick-add-trigger]",
        quickAddOptions: "[js-quick-add-options]",
        quickAddVariant: "[js-quick-add-variant]",
        addBundle: "[js-bundle-add-to-cart]",
        selectAddBundle: "[js-select-bundle-add-to-cart]",
      });
  }
  connectedCallback() {
    (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.addToCart = this.querySelectorAll(this._selectors.addToCart)),
      (this.selectAddToCart = this.querySelectorAll(
        this._selectors.selectAddToCart
      )),
      (this.addBundle = this.querySelectorAll(this._selectors.addBundle)),
      (this.selectAddBundle = this.querySelectorAll(
        this._selectors.selectAddBundle
      )),
      (this.quickAdd = this.querySelector(this._selectors.quickAdd)),
      (this.quickAddTrigger = this.querySelector(
        this._selectors.quickAddTrigger
      )),
      (this.quickAddOptions = this.querySelector(
        this._selectors.quickAddOptions
      )),
      (this.quickAddVariants = this.querySelectorAll(
        this._selectors.quickAddVariant
      )),
      this._setupListeners();
  }
  _setupListeners() {
    this.addToCart.forEach((e) => {
      e.addEventListener("click", this._addToCart);
    }),
      this.selectAddToCart.forEach((e) => {
        e.addEventListener("click", this._selectAddToCart);
      }),
      this.addBundle.forEach((e) => {
        e.addEventListener("click", this._addBundleToCart);
      }),
      this.selectAddBundle.forEach((e) => {
        e.addEventListener("change", this._selectAddBundleToCart);
      }),
      this.quickAddTrigger &&
      (this.quickAddTrigger.addEventListener("click", this._toggleQuickAdd),
        this.quickAddTrigger.addEventListener("click", (e) => {
          e.stopPropagation();
        })),
      this.quickAddVariants.forEach((e) => {
        e.addEventListener("click", this._selectVariant);
      });
  }
  _cartAdd(e, t) {
    e = {
      items: [{ id: e, quantity: 1 }],
      sections: this.cart.getSectionsToRender().map((e) => e.id),
    };
    t && (e.items[0].selling_plan = t),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            document.querySelector("cart-items") &&
            document.querySelector("cart-items").onCartUpdate(),
            this.cart.renderContents(e),
            "true" == this.cartDrawer.getAttribute("aria-hidden") &&
            this.cartDrawer.open(),
            this.quickAddTrigger &&
            this.quickAddOptions &&
            this._closeQuickAdd(),
            this.selectAddToCart &&
            this.selectAddToCart.forEach((e) => {
              e.selectedIndex = 0;
            }),
            (() => {
              const megamenu = this.closest("s-drawer-megamenu");
              if (megamenu && typeof megamenu.close === "function") megamenu.close();
            })(),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          this.cart.updateLiveItemCount(e);
          updateMultipleCartBubbles(); // 🔥 Aggiunto qui
        })
        .catch((e) => {
          console.log(e);
        });
  }
  _bundleAdd(e, t, s) {
    var r = {
      items: [],
      sections: this.cart.getSectionsToRender().map((e) => e.id),
    };
    let i = new Date();
    (t = JSON.parse(t)), (e = { id: e, quantity: 1 });
    t.forEach((e) => {
      (e.selling_plan = e[s]),
        delete e.plan_1,
        delete e.plan_2,
        delete e.plan_3;
    }),
      (r.items = t),
      r.items.push(e),
      r.items.forEach((e) => {
        (e.properties = {}), (e.properties._bundleId = i);
      }),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(r),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            document.querySelector("cart-items") &&
            document.querySelector("cart-items").onCartUpdate(),
            this.cart.renderContents(e),
            "true" == this.cartDrawer.getAttribute("aria-hidden") &&
            this.cartDrawer.open(),
            this.selectAddBundle &&
            this.selectAddBundle.forEach((e) => {
              e.selectedIndex = 0;
            }),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          this.cart.updateLiveItemCount(e);
          updateMultipleCartBubbles(); // 🔥 Aggiunto qui
        })
        .catch((e) => {
          console.log(e);
        });
  }
  _addToCart = (e) => {
    e.preventDefault();
    e = e.currentTarget;
    "" != e.dataset.variantId &&
      this._cartAdd(e.dataset.variantId, e.dataset.sellingPlan);
  };
  _selectAddToCart = (e) => {
    e.preventDefault();
    e = e.currentTarget;
    "" != e.dataset.variantId && this._cartAdd(e.dataset.variantId, e.value);
  };
  _addBundleToCart = (e) => {
    e.preventDefault();
    e = e.currentTarget;
    "" != e.dataset.variantId &&
      this._bundleAdd(e.dataset.variantId, e.dataset.bundleProducts, "plan_2");
  };
  _selectAddBundleToCart = (e) => {
    e.preventDefault();
    e = e.currentTarget;
    "" != e.dataset.variantId &&
      this._bundleAdd(e.dataset.variantId, e.dataset.bundleProducts, e.value);
  };
  _selectVariant = (e) => {
    e.preventDefault();
    const t = e.currentTarget;
    this.addToCart.forEach((e) => {
      e.dataset.variantId = t.dataset.variantId;
    }),
      this.quickAddTrigger.classList.add("hidden"),
      this.quickAddOptions.classList.add("hidden"),
      this.quickAddOptions.classList.add("!opacity-0"),
      this.quickAdd.classList.remove("hidden"),
      this.quickAdd.focus();
  };
  _toggleQuickAdd = (e) => {
    this.quickAddTrigger.classList.add("hidden"),
      this.quickAddOptions.classList.remove("hidden"),
      this.quickAddOptions.classList.remove("!opacity-0"),
      document.addEventListener("click", this._handleOutsideClick);
  };
  _closeQuickAdd = (e) => {
    this.quickAdd.classList.add("hidden"),
      this.quickAddOptions.classList.add("hidden"),
      this.quickAddOptions.classList.remove("!opacity-0"),
      this.quickAddTrigger.classList.remove("hidden"),
      this.addToCart.forEach((e) => {
        e.dataset.variantId = "";
      }),
      document.removeEventListener("click", this._handleOutsideClick);
  };
  _handleOutsideClick = (e) => {
    e.target.closest(this._selectors.quickAddOptions) ||
      e.target.closest(this._selectors.quickAddTrigger) ||
      this._closeQuickAdd();
  };
}
class DoubleCarousel extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        mainCarousel: "[js-hero-carousel]",
        subCarousel: "[js-mobile-content]",
      }),
      (this.mainOptions = {
        loop: !0,
        slidesPerView: "auto",
        grabCursor: !0,
        autoHeight: !0,
        nested: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: { el: ".swiper-pagination", clickable: !1 },
        centeredSlides: !1,
      }),
      (this.subOptions = {
        loop: !0,
        slidesPerView: "auto",
        grabCursor: !0,
        autoHeight: !0,
        nested: !0,
        centeredSlides: !1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: { el: ".swiper-pagination", clickable: !1 },
      });
  }
  connectedCallback() {
    this._initDoubleCarousel();
  }
  _initDoubleCarousel() {
    let e = "#" + this.querySelector(this.selectors.mainCarousel).id,
      t = "#" + this.querySelector(this.selectors.subCarousel).id;
    const s = this.dataset.autoplay ? Number(this.dataset.autoplay) : 0;
    void 0 !== this.dataset.init
      ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
        match: function () {
          (this.mainCarousel = new Swiper(e, this.mainOptions)),
            (this.subCarousel = new Swiper(t, this.subOptions)),
            0 !== s &&
            ((this.mainCarousel.params.autoplay.delay = s),
              this.mainCarousel.autoplay.start()),
            (this.mainCarousel.controller.control = this.subCarousel),
            (this.subCarousel.controller.control = this.mainCarousel);
        }.bind(this),
        unmatch: function () {
          this.carousel.el.classList.contains("swiper-initialized") &&
            (this.mainCarousel.destroy(!0, !0),
              this.subCarousel.destroy(!0, !0));
        }.bind(this),
      })
      : ((this.mainCarousel = new Swiper(e, this.mainOptions)),
        (this.subCarousel = new Swiper(t, this.subOptions)),
        0 !== s &&
        ((this.mainCarousel.params.autoplay.delay = s),
          this.mainCarousel.autoplay.start()),
        (this.mainCarousel.controller.control = this.subCarousel),
        (this.subCarousel.controller.control = this.mainCarousel));
  }
}
class ProductStickyBar extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        productOptionSelector: "[js-product-option-selector]",
        stickyAddToCart: "[js-sticky-atc]",
        stickyOptionSelector: "[js-sticky-option-selector]",
        productForm: "[js-product-form]",
        header: "#shopify-section-header",
        stickyScrollBack: "[js-sticky-scroll-back]",
        scrollTo: "[js-scroll-to]",
      });
  }
  connectedCallback() {
    (this.referenceButton = document.querySelector(this._selectors.addToCart)),
      (this.referenceSelector = document.querySelector(
        this._selectors.productOptionSelector
      )),
      (this.stickyAddToCart = this.querySelector(
        this._selectors.stickyAddToCart
      )),
      (this.stickyOptionSelector = this.querySelector(
        this._selectors.stickyOptionSelector
      )),
      (this.productForm = document.querySelector(this._selectors.productForm)),
      (this.header = document.querySelector(this._selectors.header)),
      (this.stickyScrollBack = this.querySelector(
        this._selectors.stickyScrollBack
      ));
    //this._toggleStickyBar(),
    //this._setListeners();
  }
  _setListeners = () => {
    document.addEventListener("scroll", this._toggleStickyBar),
      this.stickyOptionSelector.addEventListener(
        "change",
        this._handleOptionSelect
      ),
      this.stickyScrollBack &&
      this.stickyScrollBack.addEventListener("click", this._handleScrollBack);
  };
  _toggleStickyBar = () => {
    this.productForm.getBoundingClientRect().bottom < this.header.clientHeight
      ? (this.classList.remove("hidden"), this.classList.add("block"))
      : (this.classList.add("hidden"), this.classList.remove("block"));
  };
  _handleOptionSelect = (e) => {
    e = e.currentTarget.value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    (this.referenceSelector.value = e),
      this.referenceSelector.dispatchEvent(new Event("change"));
  };
  _handleScrollBack = (e) => {
    var t =
      document.querySelector(this._selectors.scrollTo).getBoundingClientRect()
        .top +
      window.pageYOffset -
      100;
    window.scrollTo({ top: t, behavior: "smooth" });
  };
}
class Video extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        video: "video",
        playBtn: "[js-play-video]",
        pauseBtn: "[js-pause-video]",
      });
  }
  connectedCallback() {
    (this.video = this.querySelector(this._selectors.video)),
      (this.playBtn = this.querySelector(this._selectors.playBtn)),
      (this.pauseBtn = this.querySelector(this._selectors.pauseBtn)),
      this._setupListeners();
  }
  _setupListeners() {
    this.playBtn.addEventListener("click", this._playVideo),
      this.pauseBtn.addEventListener("click", this._pauseVideo);
  }
  _playVideo = () => {
    this.video.play(),
      this.playBtn.classList.toggle("hidden"),
      this.pauseBtn.classList.toggle("hidden");
  };
  _pauseVideo = () => {
    this.video.pause(),
      this.playBtn.classList.toggle("hidden"),
      this.pauseBtn.classList.toggle("hidden");
  };
}
class Dropdown extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        select: "[js-select]",
        selectText: "[js-select-text]",
        selectOptions: "[js-select-options]",
        selectWrapper: "[js-select-wrapper]",
        option: "[js-option]",
        label: "[js-label]",
      });
  }
  connectedCallback() {
    (this.selects = this.querySelectorAll(this._selectors.select)),
      (this.options = this.querySelectorAll(this._selectors.option)),
      this._setListeners();
  }
  _setListeners() {
    this.selects.forEach((e) => {
      e.addEventListener("click", this._toggleSelect);
    }),
      this.options.forEach((e) => {
        e.addEventListener("click", this._handleOptionSelect);
      }),
      document.addEventListener("click", this._handleClick),
      document.querySelectorAll("s-drawer").forEach((e) => {
        e.addEventListener("click", this._handleClick);
      });
  }
  _toggleSelect = (e) => {
    var e = e.currentTarget,
      t = this.querySelector(this._selectors.selectOptions),
      s = this.querySelector(this._selectors.selectWrapper),
      r = this.querySelectorAll(this._selectors.label);
    t.clientHeight
      ? (e.classList.remove("rounded-b-none"),
        (t.style.height = 0),
        t.classList.remove("border"),
        r.forEach((e) => {
          e.setAttribute("tabindex", "-1");
        }))
      : (e.classList.add("rounded-b-none"),
        (t.style.height = "auto"),
        t.classList.add("border"),
        r.forEach((e) => {
          e.setAttribute("tabindex", "0");
        }));
  };
  _closeSelects = (e) => {
    var t = document.querySelectorAll(this._selectors.select),
      s = document.querySelectorAll(this._selectors.selectOptions);
    document.querySelectorAll(this._selectors.selectWrapper);
    s.forEach((e) => {
      (e.style.height = 0), e.classList.remove("border");
    }),
      t.forEach((e) => {
        e.classList.remove("rounded-b-none");
      });
  };
  _handleOptionSelect = (e) => {
    var t = this.dataset.sync,
      t = document.getElementById(t);
    this.querySelector(this._selectors.selectText),
      e.currentTarget.nextElementSibling.getAttribute("value-name");
    e.currentTarget.name.includes("watch")
      ? e.currentTarget.name.split("watch-")[1]
      : (t.value = e.currentTarget.value),
      t.dispatchEvent(new Event("change")),
      this._closeSelects();
  };
  _handleClick = (e) => {
    var t;
    this.contains(e.target) ||
      ((e = this.querySelector(this._selectors.select)),
        (t = this.querySelector(this._selectors.selectOptions)) &&
        ((t.style.height = 0), t.classList.remove("border")),
        e && e.classList.remove("rounded-b-none"));
  };
}

class VariantDropdown extends HTMLElement {
  constructor() {
    super();
    this._selectors = {
      select: "[js-select]",
      selectOptions: "[js-select-options]",
      option: "[js-option]",
      label: "[js-label]",
    };
  }

  connectedCallback() {
    this.select = this.querySelector(this._selectors.select);
    this.options = this.querySelectorAll(this._selectors.option);
    this.selectOptions = this.querySelector(this._selectors.selectOptions);
    this._setListeners();
  }

  _setListeners() {
    this.select.addEventListener("click", this._toggleSelect);
    this.options.forEach((option) => {
      option.addEventListener("click", this._handleOptionClick);
    });
    document.addEventListener("click", this._handleOutsideClick);
  }

  _toggleSelect = (e) => {
    e.preventDefault();
    const isOpen = this.selectOptions.clientHeight > 0;

    if (isOpen) {
      this._closeDropdown();
    } else {
      this._openDropdown();
    }
  };

  _openDropdown = () => {
    this.select.classList.add("rounded-b-none");
    this.select.style.borderRadius = "8px 8px 0px 0px";
    this.selectOptions.style.height = "auto";
    this.selectOptions.classList.add("border");
    this._setSiblingCtaTopRadius(true);
    this.querySelectorAll(this._selectors.label).forEach((label) => {
      label.setAttribute("tabindex", "0");
    });
  };

  _closeDropdown = () => {
    this.select.classList.remove("rounded-b-none");
    this.select.style.borderRadius = "";
    this.selectOptions.style.height = "0";
    this.selectOptions.classList.remove("border");
    this._setSiblingCtaTopRadius(false);
    this.querySelectorAll(this._selectors.label).forEach((label) => {
      label.setAttribute("tabindex", "-1");
    });
  };

  _setSiblingCtaTopRadius = (isOpen) => {
    const buttonStack = this.closest(".product-card__buttons");
    if (!buttonStack) return;
    buttonStack
      .querySelectorAll("button.product-card__button:not([js-select])")
      .forEach((button) => {
        if (isOpen) {
          button.style.borderTopLeftRadius = "8px";
          button.style.borderTopRightRadius = "8px";
        } else {
          button.style.borderTopLeftRadius = "";
          button.style.borderTopRightRadius = "";
        }
      });
  };

  _handleOptionClick = (e) => {
    const productUrl = e.currentTarget.dataset.productUrl;
    if (productUrl) {
      window.location.href = productUrl;
    }
  };

  _handleOutsideClick = (e) => {
    if (!this.contains(e.target)) {
      this._closeDropdown();
    }
  };
}

function updateMultipleCartBubbles() {
  fetch('/?sections=cart-icon-bubble')
    .then((res) => res.json())
    .then((sections) => {
      const html = sections['cart-icon-bubble'];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const updatedContent = doc.querySelector('#cart-icon-bubble')?.innerHTML;

      if (updatedContent) {
        const targets = ['cart-icon-bubble-1', 'cart-icon-bubble-2', 'cart-icon-bubble-3'];
        targets.forEach((id) => {
          const el = document.getElementById(id);
          if (el) {
            el.innerHTML = updatedContent;

            const isHome = document.body.classList.contains('template-index');
             if (!isHome && id !== 'cart-icon-bubble-1' && id !== 'cart-icon-bubble-3') {
                el.querySelector('.cart-count__container')?.classList.add('bg-dblack');
              }
          }
        });
      }
    })
    .catch((err) => console.error('Errore aggiornando cart-icon-bubble:', err));
}


  customElements.define("s-drawer", Drawer),
  customElements.define("size-drawer", SizeDrawer),
  customElements.define("s-modal", Modal),
  customElements.define("s-accordion", Accordion),
  customElements.define("s-tabs", Tabs),
  customElements.define("s-carousel", Carousel),
  customElements.define("s-double-carousel", DoubleCarousel),
  customElements.define("s-video", Video),
  customElements.define("s-dropdown", Dropdown),
  customElements.define("s-variant-dropdown", VariantDropdown),
  customElements.define("cart-remove-button", CartRemoveButton),
  customElements.define("cart-items", CartItems),
  customElements.define("cart-note", CartNote),
  customElements.define("cart-drawer", CartDrawer),
  customElements.define("cart-drawer-items", CartDrawerItems),
  customElements.define("s-header", SiteHeader),
  customElements.define("product-options", ProductOptions),
  customElements.define("quantity-input", QuantityInput),
  customElements.define("loading-spinner", LoadingSpinner),
  customElements.define("predictive-search", PredictiveSearch),
  customElements.define("filter-sort", FilterSort),
  customElements.define("active-filters", ActiveFilters),
  customElements.define("price-range", PriceRange),
  customElements.define("product-card", ProductCard),
  customElements.define("product-sticky-bar", ProductStickyBar),
  customElements.define("cart-upsell", CartUpsell);
class CollectionGrid extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        productGrid: "[js-products-grid]",
        toggleGrid: "[js-toggle-grid]",
        filterSort: "[js-filter-sort]",
        sortController: "[js-sort-controller]",
      }),
      (this._refresh = [
        "[js-products-grid]",
        "[js-collection-sort]",
        "[js-collection-pagination]",
      ]),
      (this._cache = []);
  }
  connectedCallback() {
    (this._sort = this.querySelector(this._selectors.sortController)),
      this._setListeners();
  }
  _setListeners() {
    document.addEventListener("filter:change", this._handleFilterChange),
      this._sort.addEventListener("change", this._handleSortOption);
  }
  _handleFilterChange = (e) => {
    (e = e.detail.parsedHTML),
      (e = e.querySelector(`[data-id="${this.dataset.id}"]`));
    theme.utils.refreshElements(this._refresh, e, this);
  };
  _handleSortOption = (e) => {
    var e = e.currentTarget.value,
      t = document.querySelector("[js-filter-form-sort]"),
      s = document.querySelector("[js-filter-form]");
    (t.value = e), s.dispatchEvent(new Event("input"));
  };
}
class ProductMain extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        selectAddToCart: "[js-select-add-to-cart]",
        error: "[js-error-message]",
        //form: "[js-product-form]",
        loader: "loading-spinner",
        carousel: "[js-carousel]",
        thumbnail: "[js-thumbnail]",
        optionSelector: "[js-product-option-selector]",
        stickyAddToCart: "[js-sticky-atc]",
        stickyOptionSelector: "[js-sticky-option-selector]",
        priceText: "[js-price-text]",
        sizeChartTabTrigger: "[js-size-chart-tab-trigger]",
        sizeChartTabPanel: "[js-size-chart-tab-panel]",
        sizeChartHtml: "[js-size-chart-html]",
        howItWorksBtn: "[js-how-it-works-btn]",
        howItWorksPopover: "[js-how-it-works-popover]",
        variantSelectButton: "[js-update-text]",
        variantSelectDropdown: "[js-size-selector-dropdown]",
      });
  }
  connectedCallback() {
    (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.addToCart = [...this.querySelectorAll(this._selectors.addToCart)].find(
        (btn) => !btn.closest("addcart-section-pdp")
      )),
      (this.selectAddToCart = [
        ...this.querySelectorAll(this._selectors.selectAddToCart),
      ].filter((el) => !el.closest("addcart-section-pdp"))),
      (this.buttons = this.addToCart ? [this.addToCart] : []),
      (this.optionSelector = this.querySelectorAll(
        this._selectors.optionSelector
      )),
      (this.stickyOptionSelector = document.querySelector(
        this._selectors.stickyOptionSelector
      )),
      (this.stickyAddToCart = document.querySelector(
        this._selectors.stickyAddToCart
      )),
      (this.swiper = this.querySelector(this._selectors.carousel)?.swiper),
      (this.thumbnails = this.querySelectorAll(this._selectors.thumbnail)),
      (this.isBundle = "true" === this.dataset.isBundle),
      (this.priceText = this.querySelector(this._selectors.priceText)),
      (this.howItWorksBtn = this.querySelector(this._selectors.howItWorksBtn)),
      (this.howItWorksPopover = this.querySelector(
        this._selectors.howItWorksPopover
      )),
      (this.stickyAtcClicked = !1),
      this.stickyAddToCart &&
      (this.buttons.push(this.stickyAddToCart),
        this.stickyAddToCart.addEventListener("click", this._stickyATCclick)),
      this.swiper ? this._bindCarousel() : this.addEventListener("carousel:ready", (e) => {
        this.swiper = e.detail?.swiper;
        if (this.swiper) this._bindCarousel();
      }, { once: true }),
      this.optionSelector &&
      this.optionSelector.forEach((e) => {
        e.addEventListener("change", this._handleOptionSelect);
      }),
      this.howItWorksBtn &&
      (this.howItWorksBtn.addEventListener(
        "mouseenter",
        this._showHowItWorks
      ),
        this.howItWorksBtn.addEventListener("focusin", this._showHowItWorks),
        this.howItWorksPopover.addEventListener(
          "mouseenter",
          this._showHowItWorks
        ),
        this.howItWorksBtn.addEventListener("mouseleave", this._hideHowItWorks),
        this.howItWorksBtn.addEventListener("focusout", this._hideHowItWorks),
        this.howItWorksPopover.addEventListener(
          "mouseleave",
          this._hideHowItWorks
        )),
      this.addEventListener("variant:change", this._handleVariantChange),
      this.addToCart &&
        this.addToCart.addEventListener("click", this._addToCart),
      this.selectAddToCart.forEach((e) => {
        e.addEventListener("click", this._selectAddToCart);
      }),
      //this._initProductForm(),
      this._initSizeChart(),
      //this._rechargeWidget(),
      this._handleShopPayLogo();
  }
  _bindCarousel() {
    if (!this.swiper) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.swiper.params.speed = 0;
    }
    this.swiper.on("slideChange", this._handleSlideChange);
    this.thumbnails.forEach((e) => {
      e.addEventListener("click", this._handleThumbnailClick);
    });
    this._syncGalleryAccessibility();
  }
  _initProductForm() {
    (this.form = this.querySelector(this._selectors.form)),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer"));
  }
  _initSizeChart() {
    this._initSizeChartTabs(), this._initSizeChartConversion();
  }
  _initSizeChartTabs() {
    const s = this.querySelectorAll(this._selectors.sizeChartTabTrigger),
      r = this.querySelectorAll(this._selectors.sizeChartTabPanel);
    function i(e) {
      var t = this.querySelector("#" + e.getAttribute("aria-controls"));
      s.forEach((e) => {
        e.setAttribute("aria-selected", "false"),
          e.setAttribute("tabindex", "-1");
      }),
        r.forEach((e) => {
          (e.hidden = !0), e.classList.add("hidden");
        }),
        e.setAttribute("aria-selected", "true"),
        e.setAttribute("tabindex", "0"),
        (t.hidden = !1),
        t.classList.remove("hidden");
    }
    r.forEach((e) => {
      var t = e.querySelector(this._selectors.sizeChartHtml);
      e.innerHTML += t?.innerHTML || "";
    }),
      s.forEach((t) => {
        t.addEventListener("click", () => {
          i.call(this, t);
        }),
          t.addEventListener("keydown", (e) => {
            ("ArrowRight" !== e.key && "ArrowLeft" !== e.key) ||
              ((e = "ArrowRight" === e.key ? 1 : -1),
                (e =
                  s[
                  (Array.prototype.indexOf.call(s, t) + e + s.length) % s.length
                  ]).focus(),
                i.call(this, e));
          });
      });
  }
  _initSizeChartConversion() {
    var e = this.querySelector(
      this._selectors.sizeChartTabPanel + '[data-type="centimeter"]'
    );
    e &&
      [...e.querySelectorAll("td")]
        .concat([...e.querySelectorAll("th")])
        .forEach((e) => {
          theme.utils.isNumeric(e.innerHTML) &&
            (e.innerHTML = theme.utils.inchesToCm(parseFloat(e.innerHTML)));
        });
  }
  _cartAdd(e, t) {
    e = {
      items: [{ id: e, quantity: 1 }],
      sections: this.cart.getSectionsToRender().map((e) => e.id),
    };
    t && (e.items[0].selling_plan = t),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            document.querySelector("cart-items") &&
            document.querySelector("cart-items").onCartUpdate(),
            this.cart.renderContents(e),
            "true" == this.cartDrawer.getAttribute("aria-hidden") &&
            this.cartDrawer.open(),
            this.quickAddTrigger &&
            this.quickAddOptions &&
            this._closeQuickAdd(),
            this.selectAddToCart &&
            this.selectAddToCart.forEach((e) => {
              e.selectedIndex = 0;
            }),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          this.cart.updateLiveItemCount(e);
          updateMultipleCartBubbles();
        })
        .catch((e) => {
          console.log(e);
        });
  }
  _addToCart = (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    let variantId = btn.dataset.variantId;
    if (!variantId) {
      const masterSelect = this.querySelector('select[name="id"]');
      variantId = masterSelect ? masterSelect.value : null;
    }
    if (variantId && variantId !== '') {
      this._cartAdd(variantId, btn.dataset.sellingPlan);
    }
  };
  _selectAddToCart = (e) => {
    e.preventDefault();
    e = e.currentTarget;
    "" != e.dataset.variantId && this._cartAdd(e.dataset.variantId, e.value);
  };
  _rechargeWidget() {
    var s = this,
      e = this.querySelector(this._selectors.form);
    new MutationObserver(function (e, t) {
      e.forEach((e) => {
        "childList" == e.type &&
          e.target.classList.contains("rc_container_wrapper") &&
          s._rechargeListeners(e.target);
      }),
        t.disconnect();
    }).observe(e, { attributes: !0, childList: !0, subtree: !0 });
  }
  _rechargeListeners(e) {
    var t = e.querySelectorAll(".rc-radio__input");
    let s = e.querySelector(".rc_popup");
    t.forEach((e) => {
      e.addEventListener("change", (e) => {
        e.target.classList.contains("rc_widget__option__input--onetime")
          ? s.classList.add("!hidden")
          : s.classList.remove("!hidden");
      });
    });
  }
  onSubmitHandler(e) {
    if (
      (e.preventDefault(),
        this.handleErrorMessage(),
        this._disableButtons(),
        this.isBundle)
    )
      this._handleBundleAdd();
    else {
      e = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      const t = new FormData(this.form);
      this.cart &&
        (t.append(
          "sections",
          this.cart.getSectionsToRender().map((e) => e.id)
        ),
          t.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
        (e.body = t),
        fetch("" + window.routes.cart_add_url, e)
          .then((e) => e.json())
          .then((e) => {
            if (e.status)
              theme.utils.subscriptions.publish(
                window.PUB_SUB_EVENTS.cartError,
                {
                  source: "product-form",
                  productVariantId: t.get("id"),
                  errors: e.errors || e.description,
                  message: e.message,
                }
              ),
                this.handleErrorMessage(e.description),
                (this.error = !0);
            else {
              if (this.cart)
                return (
                  this.error ||
                  theme.utils.subscriptions.publish(
                    window.PUB_SUB_EVENTS.cartUpdate,
                    { source: "product-form", productVariantId: t.get("id") }
                  ),
                  (this.error = !1),
                  this.cart.renderContents(e),
                  this.cartDrawer.open(),
                  updateMultipleCartBubbles(),
                  fetch(window.routes.cart_url + "?section_id=cart__main")
                );
              window.location = window.routes.cart_url;
            }
          })
          .then((e) => e.text())
          .then((e) => {
            this.cart.updateLiveItemCount(e);
          })
          .catch((e) => {
            this.handleErrorMessage(e.description), console.error(e);
          })
          .finally(() => {
            this._enableButtons();
          });
    }
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      e
        ? ((this.errorMessageWrapper.innerHTML = e),
          this.errorMessageWrapper.classList.remove("hidden"),
          1 == this.stickyAtcClicked &&
          (this.errorMessageWrapper.scrollIntoView(!1),
            (this.stickyAtcClicked = !1)))
        : this.errorMessageWrapper.classList.add("hidden");
  }
  _updateAddToCartState(e) {
    this.buttons.forEach((btn) => {
      const label = btn.querySelector("[js-atc-text]");
      if (!label) return;
      if (e) {
        if (e.available) {
          label.innerHTML = theme.utils.buildPdpBuyButtonLabelHtml(e, btn);
          btn.removeAttribute("disabled");
        } else {
          // Variant selected but unavailable.
          label.textContent = "Sold out";
          btn.setAttribute("disabled", "");
        }
      } else {
        // No matching variant.
        label.textContent = "Unavailable";
        btn.setAttribute("disabled", "");
      }
    });
  }
  _updatePrice(e) {
    this.priceText.textContent = theme.utils.formatMoney(
      e.price,
      theme.config.money.format
    );
  }
  _disableButtons() {
    this.buttons.forEach((e) => {
      e.setAttribute("disabled", "");
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.buttons.forEach((e) => {
      e.removeAttribute("disabled");
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
  _setActiveThumbnail(t) {
    this.thumbnails.forEach((e) => {
      e.dataset.index == t
        ? e.classList.add("active")
        : e.classList.remove("active");
    });
  }
  _updateVariantInputLabel(e) {
    if (this.querySelector(this._selectors.variantSelectButton)) {
      this.querySelector(this._selectors.variantSelectButton).innerText = e
        ? e.option1 ? `Size: ${e.option1}` : 'Select size'
        : 'Select size';
      this.querySelector(this._selectors.variantSelectDropdown)._closeDropdown();
    }
  }
  _handleVariantChange = (e) => {
    var { variant: e, priceChange: t } = e.detail;
    this._updateAddToCartState(e), this._updateVariantInputLabel(e), e && t && this._updatePrice(e);
  };
  _handleThumbnailClick = (e) => {
    (e = e.currentTarget), (e = Number(e.dataset.index));
    this.swiper.slideToLoop(e), this._setActiveThumbnail(e);
  };
  _handleSlideChange = () => {
    this._setActiveThumbnail(Number(this.swiper.realIndex));
    this._syncGalleryAccessibility();
  };
  /**
   * Keep gallery slides, nav, pagination, live region, and media in sync for
   * keyboard / screen reader users after Swiper changes the active slide.
   */
  _syncGalleryAccessibility = () => {
    if (!this.swiper?.slides) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const gallery = this.querySelector(".product__images");
    const carousel = gallery?.querySelector("s-carousel");
    const mediaCount = parseInt(gallery?.querySelector("[data-media-count]")?.dataset.mediaCount, 10);
    const total = mediaCount || this.swiper.slides.length;
    const current = (typeof this.swiper.realIndex === "number" ? this.swiper.realIndex : 0) + 1;

    this.swiper.slides.forEach((slide) => {
      if (!(slide instanceof HTMLElement)) return;
      const isActive = slide.classList.contains("swiper-slide-active");
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      if (isActive) {
        slide.removeAttribute("inert");
      } else {
        slide.setAttribute("inert", "");
      }

      const video = slide.querySelector("video");
      if (!video) return;
      if (isActive && !reduceMotion) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    const labelEl = document.getElementById("ProductGallerySlideLabel-" + this.dataset.sectionId);
    if (labelEl) {
      const template = carousel?.dataset.slideStatusTemplate || "Slide __INDEX__ of __COUNT__";
      labelEl.textContent = template
        .replace(/__INDEX__/g, String(current))
        .replace(/__COUNT__/g, String(total));
    }

    const looping = Boolean(this.swiper.params.loop);
    const prev = gallery?.querySelector(".swiper-button-prev, .product-main-images__prev-button");
    const next = gallery?.querySelector(".swiper-button-next, .product-main-images__next-button");
    if (prev && next) {
      const atStart = !looping && this.swiper.isBeginning;
      const atEnd = !looping && this.swiper.isEnd;
      prev.setAttribute("aria-disabled", atStart ? "true" : "false");
      next.setAttribute("aria-disabled", atEnd ? "true" : "false");
      prev.tabIndex = atStart ? -1 : 0;
      next.tabIndex = atEnd ? -1 : 0;
    }

    gallery?.querySelectorAll(".swiper-pagination-bullet").forEach((bullet, index) => {
      if (index === this.swiper.realIndex) {
        bullet.setAttribute("aria-current", "true");
      } else {
        bullet.removeAttribute("aria-current");
      }
    });
  };
  _stickyATCclick = (e) => {
    e.preventDefault(),
      e.stopImmediatePropagation(),
      (this.stickyAtcClicked = !0),
      this.addToCart.click();
  };
  _handleOptionSelect = (e) => {
    e = e.currentTarget.value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    (this.isBundle = "subscription" == e),
      (this.stickyOptionSelector.value = e);
  };
  _handleBundleAdd = () => {
    var e = {
      items: [],
      sections: this.cart.getSectionsToRender().map((e) => e.id),
    };
    let t = new Date();
    var s = this.querySelector("[data-bundle-products]"),
      s = JSON.parse(s.dataset.bundleProducts),
      r = this.form,
      i = {
        id: r.querySelector("#" + r.dataset.masterSelect).value,
        quantity: 1,
      };
    let n = r.querySelector("[js-frequency-select]").value;
    s.forEach((e) => {
      (e.selling_plan = e["plan_" + n]),
        delete e.plan_1,
        delete e.plan_2,
        delete e.plan_3;
    }),
      (e.items = s),
      e.items.push(i),
      e.items.forEach((e) => {
        (e.properties = {}), (e.properties._bundleId = t);
      }),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            document.querySelector("cart-items") &&
            document.querySelector("cart-items").onCartUpdate(),
            this.cart.renderContents(e),
            "true" == this.cartDrawer.getAttribute("aria-hidden") &&
            this.cartDrawer.open(),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          this.cart.updateLiveItemCount(e);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this._enableButtons();
        });
  };
  _handleShopPayLogo() {
    var e = document
      .querySelector("shopify-payment-terms")
      ?.shadowRoot?.querySelector("shop-pay-installments-banner")
      ?.shadowRoot?.querySelector("#shopify-installments")
      ?.querySelector("shop-pay-logo")
      ?.shadowRoot?.querySelector("svg"),
      t = document.querySelector("shopify-payment-terms")?.parentElement
        ?.dataset?.useBlack;
    e && "true" === t && (e.style.filter = "brightness(0)");
  }
  _showHowItWorks = (e) => {
    this.howItWorksPopover.classList.remove("hidden"),
      this.howItWorksPopover.classList.add("z-[1000]");
  };
  _hideHowItWorks = (e) => {
    this.howItWorksPopover.classList.add("hidden"),
      this.howItWorksPopover.classList.remove("z-[1000]");
  };
}

class ProductShoes extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        error: "[js-error-message]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        carousel: "[js-carousel]",
        thumbnail: "[js-thumbnail]",
        optionSelector: "[js-product-option-selector]",
        stickyAddToCart: "[js-sticky-atc]",
        stickyOptionSelector: "[js-sticky-option-selector]",
        priceText: "[js-price-text]",
        variantSelectButton: "[js-update-text]",
        variantSelectDropdown: "[js-size-selector-dropdown]",
      });
  }
  connectedCallback() {
    (this.cart = document.querySelector("cart-drawer")),
      (this.addToCart = this.querySelector(this._selectors.addToCart)),
      (this.buttons = [this.addToCart]),
      (this.optionSelector = this.querySelectorAll(
        this._selectors.optionSelector
      )),
      (this.stickyOptionSelector = document.querySelector(
        this._selectors.stickyOptionSelector
      )),
      (this.stickyAddToCart = document.querySelector(
        this._selectors.stickyAddToCart
      )),
      (this.swiper = this.querySelector(this._selectors.carousel)?.swiper),
      (this.thumbnails = this.querySelectorAll(this._selectors.thumbnail)),
      (this.isBundle = "true" === this.dataset.isBundle),
      (this.priceText = this.querySelector(this._selectors.priceText)),
      (this.stickyAtcClicked = !1),
      this.stickyAddToCart &&
      (this.buttons.push(this.stickyAddToCart),
        this.stickyAddToCart.addEventListener("click", this._stickyATCclick)),
      this.swiper ? this._bindCarousel() : this.addEventListener("carousel:ready", (e) => {
        this.swiper = e.detail?.swiper;
        if (this.swiper) this._bindCarousel();
      }, { once: true }),
      this.optionSelector &&
      this.optionSelector.forEach((e) => {
        e.addEventListener("change", this._handleOptionSelect);
      }),
      this.addEventListener("variant:change", this._handleVariantChange),
      this._initProductForm(),
      this._rechargeWidget(),
      this._handleShopPayLogo();
  }
  _bindCarousel() {
    if (!this.swiper) return;
    this.swiper.on("slideChangeTransitionEnd", this._handleSlideChange);
    this.thumbnails.forEach((e) => {
      e.addEventListener("click", this._handleThumbnailClick);
    });
  }
  _initProductForm() {
    (this.form = this.querySelector(this._selectors.form)),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer"));
  }
  _rechargeWidget() {
    var s = this,
      e = this.querySelector(this._selectors.form);
    new MutationObserver(function (e, t) {
      e.forEach((e) => {
        "childList" == e.type &&
          e.target.classList.contains("rc_container_wrapper") &&
          s._rechargeListeners(e.target);
      }),
        t.disconnect();
    }).observe(e, { attributes: !0, childList: !0, subtree: !0 });
  }
  _rechargeListeners(e) {
    var t = e.querySelectorAll(".rc-radio__input");
    let s = e.querySelector(".rc_popup");
    t.forEach((e) => {
      e.addEventListener("change", (e) => {
        e.target.classList.contains("rc_widget__option__input--onetime")
          ? s.classList.add("!hidden")
          : s.classList.remove("!hidden");
      });
    });
  }
  onSubmitHandler(e) {
    if (
      (e.preventDefault(),
        this.handleErrorMessage(),
        this._disableButtons(),
        this.isBundle)
    )
      this._handleBundleAdd();
    else {
      e = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      const t = new FormData(this.form);
      this.cart &&
        (t.append(
          "sections",
          this.cart.getSectionsToRender().map((e) => e.id)
        ),
          t.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
        (e.body = t),
        fetch("" + window.routes.cart_add_url, e)
          .then((e) => e.json())
          .then((e) => {
            if (e.status)
              theme.utils.subscriptions.publish(
                window.PUB_SUB_EVENTS.cartError,
                {
                  source: "product-form",
                  productVariantId: t.get("id"),
                  errors: e.errors || e.description,
                  message: e.message,
                }
              ),
                this.handleErrorMessage(e.description),
                (this.error = !0);
            else {
              if (this.cart)
                return (
                  this.error ||
                  theme.utils.subscriptions.publish(
                    window.PUB_SUB_EVENTS.cartUpdate,
                    { source: "product-form", productVariantId: t.get("id") }
                  ),
                  (this.error = !1),
                  this.cart.renderContents(e),
                  this.cartDrawer.open(),
                  updateMultipleCartBubbles(),
                  fetch(window.routes.cart_url + "?section_id=cart__main")
                );
              window.location = window.routes.cart_url;
            }
          })
          .then((e) => e.text())
          .then((e) => {
            this.cart.updateLiveItemCount(e);
          })
          .catch((e) => {
            this.handleErrorMessage(e.description), console.error(e);
          })
          .finally(() => {
            this._enableButtons();
          });
    }
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      e
        ? ((this.errorMessageWrapper.innerHTML = e),
          this.errorMessageWrapper.classList.remove("hidden"),
          1 == this.stickyAtcClicked &&
          (this.errorMessageWrapper.scrollIntoView(!1),
            (this.stickyAtcClicked = !1)))
        : this.errorMessageWrapper.classList.add("hidden");
  }

  _updateVariantInputLabel(e) {
    if (this.querySelector(this._selectors.variantSelectButton)) {
      this.querySelector(this._selectors.variantSelectButton).innerText = e
        ? e.option1
          ? `Size: ${e.option1}`
          : 'Select size'
        : 'Select size';
        this.querySelector(this._selectors.variantSelectDropdown)._closeDropdown();
    }
  }

  _updateAddToCartState(e) {
    this.buttons.forEach((btn) => {
      const label = btn.querySelector("[js-atc-text]");
      if (!label) return;
      if (e) {
        if (e.available) {
          label.innerHTML = theme.utils.buildPdpBuyButtonLabelHtml(e, btn);
          btn.removeAttribute("disabled");
        } else {
          label.textContent = "Sold out";
          btn.setAttribute("disabled", "");
        }
      } else {
        label.textContent = "Unavailable";
        btn.setAttribute("disabled", "");
      }
    });
  }
  _updatePrice(e) {
    this.priceText.textContent = theme.utils.formatMoney(
      e.price,
      theme.config.money.format
    );
  }
  _disableButtons() {
    this.buttons.forEach((e) => {
      e.setAttribute("disabled", "");
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.buttons.forEach((e) => {
      e.removeAttribute("disabled");
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
  _setActiveThumbnail(t) {
    this.thumbnails.forEach((e) => {
      e.dataset.index == t
        ? e.classList.add("active")
        : e.classList.remove("active");
    });
  }
  _handleVariantChange = (e) => {
    var { variant: e, priceChange: t } = e.detail;
    this._updateAddToCartState(e),
    this._updateVariantInputLabel(e),
     e && t && this._updatePrice(e);
  };
  _handleThumbnailClick = (e) => {
    (e = e.currentTarget), (e = Number(e.dataset.index));
    this.swiper.slideToLoop(e), this._setActiveThumbnail(e);
  };
  _handleSlideChange = (e) => {
    e.currentTarget;
    e = Number(this.swiper.realIndex);
    this._setActiveThumbnail(e),
      this.querySelector(
        ".swiper-slide-active[js-carousel-slide] video"
      )?.play();
  };
  _stickyATCclick = (e) => {
    e.preventDefault(),
      e.stopImmediatePropagation(),
      (this.stickyAtcClicked = !0),
      this.addToCart.click();
  };
  _handleOptionSelect = (e) => {
    e = e.currentTarget.value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    (this.isBundle = "subscription" == e),
      (this.stickyOptionSelector.value = e);
  };
  _handleBundleAdd = () => {
    var e = {
      items: [],
      sections: this.cart.getSectionsToRender().map((e) => e.id),
    };
    let t = new Date();
    var s = this.querySelector("[data-bundle-products]"),
      s = JSON.parse(s.dataset.bundleProducts),
      r = this.form,
      i = {
        id: r.querySelector("#" + r.dataset.masterSelect).value,
        quantity: 1,
      };
    let n = r.querySelector("[js-frequency-select]").value;
    s.forEach((e) => {
      (e.selling_plan = e["plan_" + n]),
        delete e.plan_1,
        delete e.plan_2,
        delete e.plan_3;
    }),
      (e.items = s),
      e.items.push(i),
      e.items.forEach((e) => {
        (e.properties = {}), (e.properties._bundleId = t);
      }),
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((e) => e.json())
        .then(
          (e) => (
            document.querySelector("cart-items") &&
            document.querySelector("cart-items").onCartUpdate(),
            this.cart.renderContents(e),
            "true" == this.cartDrawer.getAttribute("aria-hidden") &&
            this.cartDrawer.open(),
            fetch(window.routes.cart_url + "?section_id=cart__main")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          this.cart.updateLiveItemCount(e);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this._enableButtons();
        });
  };
  _handleShopPayLogo() {
    var e = document
      .querySelector("shopify-payment-terms")
      ?.shadowRoot?.querySelector("shop-pay-installments-banner")
      ?.shadowRoot?.querySelector("#shopify-installments")
      ?.querySelector("shop-pay-logo")
      ?.shadowRoot?.querySelector("svg"),
      t = document.querySelector("shopify-payment-terms")?.parentElement
        ?.dataset?.useBlack;
    e && "true" === t && (e.style.filter = "brightness(0)");
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    new IntersectionObserver(
      ((e, t) => {
        e[0].isIntersecting &&
          (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                var t = document.createElement("div"),
                  e =
                    ((t.innerHTML = e),
                      t.querySelector("product-recommendations"));
                e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML);
              })
              .catch((e) => {
                console.error(e);
              }));
      }).bind(this),
      { rootMargin: "0px 0px 200px 0px" }
    ).observe(this);
  }
}
class HeroLogo extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        logo: "[js-animate-logo]",
        logoContainer: "[js-animate-logo-container]",
      });
  }
  connectedCallback() {
    (this.logo = this.querySelector(this._selectors.logo)),
      (this.logoContainer = this.querySelector(this._selectors.logoContainer)),
      this._animateLogo();
  }
  _animateLogo() {
    var e = new ScrollMagic.Controller(),
      t = this.logo.offsetWidth,
      t = document.querySelector("[js-logo]").offsetWidth / t,
      s =
        this.logo.getBoundingClientRect().top -
        (this.logoContainer.classList.contains("pin-logo-60") ? 60 : 20),
      t = new TweenMax.to("#" + this.logo.id, 0.5, { scale: t }),
      t = new ScrollMagic.Scene({
        triggerElement: "#" + this.id,
        triggerHook: 0,
        duration: s,
        reverse: !0,
      }).setTween(t),
      s = new ScrollMagic.Scene({
        triggerElement: "#" + this.id,
        triggerHook: 0,
        offset: s,
        reverse: !0,
      }).setClassToggle("#" + this.logoContainer.id, "pin-logo");
    e.addScene([t, s]);
  }
}
class PageDoctor extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        menuLink: "[js-menu-link]",
        blockContent: "[js-block-content]",
      });
  }
  connectedCallback() {
    (this.menuLink = this.querySelectorAll(this._selectors.menuLink)),
      (this.blockContent = this.querySelectorAll(this._selectors.blockContent)),
      this._greenText();
  }
  _greenText() {
    var e = this.querySelectorAll(this._selectors.blockContent);
    let t = [];
    e.forEach((e) => {
      t.push(e.offsetHeight);
    });
    var s = new ScrollMagic.Controller({
      globalSceneOptions: { triggerHook: 0.025, reverse: !0 },
    });
    if (this.querySelector("[js-info]"))
      for (var r = links, i = ids, n = 0; n < r.length; n++)
        new ScrollMagic.Scene({ triggerElement: "#" + i[n] })
          .setClassToggle("#" + r[n], "active")
          .duration(t[n])
          .addTo(s);
  }
}
customElements.define("s-collection-grid", CollectionGrid),
  customElements.define("s-product", ProductMain),
  customElements.define("s-product-shoes", ProductShoes),
  customElements.define("product-recommendations", ProductRecommendations),
  customElements.define("hero-logo", HeroLogo),
  customElements.define("page-doctor", PageDoctor);
class Account extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addressCountrySelect: "[js-country-select]",
        deleteAddressButton: "[js-delete-address]",
        editAddressPrompts: "[js-edit-address-prompts]",
        editAddressElement: "[js-edit-address-element]",
        editAddressOpen: "[js-open-edit-address]",
        editAddressCancel: "[js-cancel-edit-address]",
        editAddressForm: "[js-edit-address-form]",
        addAddressElement: "[js-add-address-element]",
        addAddressOpen: "[js-open-add-address-element]",
        addAddressCancel: "[js-cancel-add-address]",
        ordersContainer: "[js-orders]",
        ordersPagination: "[js-next-page]",
        order: "[js-order]",
      });
  }
  connectedCallback() {
    (this.countrySelects = this.querySelectorAll(
      this._selectors.addressCountrySelect
    )),
      (this.deleteAddressButtons = this.querySelectorAll(
        this._selectors.deleteAddressButton
      )),
      (this.editAddressPrompts = this.querySelectorAll(
        this._selectors.editAddressPrompts
      )),
      (this.editAddressElements = this.querySelectorAll(
        this._selectors.editAddressElement
      )),
      (this.openEditAddress = this.querySelectorAll(
        this._selectors.editAddressOpen
      )),
      (this.cancelEditAddress = this.querySelectorAll(
        this._selectors.editAddressCancel
      )),
      (this.editAddressForms = this.querySelectorAll(
        this._selectors.editAddressForm
      )),
      (this.addAddressElements = this.querySelectorAll(
        this._selectors.addAddressElement
      )),
      (this.openAddAddress = this.querySelectorAll(
        this._selectors.addAddressOpen
      )),
      (this.cancelAddAddress = this.querySelectorAll(
        this._selectors.addAddressCancel
      )),
      (this.ordersContainer = this.querySelector(
        this._selectors.ordersContainer
      )),
      (this.ordersPagination = this.querySelector(
        this._selectors.ordersPagination
      )),
      this._setupCountries(),
      this._setupEventListeners();
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        { hideElement: "AddressProvinceContainerNew" }
      ),
        this.countrySelects.forEach((e) => {
          e = e.dataset.formId;
          new Shopify.CountryProvinceSelector(
            "AddressCountry_" + e,
            "AddressProvince_" + e,
            { hideElement: "AddressProvinceContainer_" + e }
          );
        }));
  }
  _setupEventListeners() {
    this.ordersPagination &&
      this.ordersPagination.addEventListener("click", this._addOrders),
      this.deleteAddressButtons.forEach((e) => {
        e.addEventListener("click", this._handleDeleteAddress);
      }),
      this.openEditAddress.forEach((e) => {
        e.addEventListener("click", this._handleOpenEditAddress);
      }),
      this.cancelEditAddress.forEach((e) => {
        e.addEventListener("click", this._handleCloseEditAddress);
      }),
      this.openAddAddress.forEach((e) => {
        e.addEventListener("click", this._handleOpenAddAddress);
      }),
      this.cancelAddAddress.forEach((e) => {
        e.addEventListener("click", this._handleCancelAddAddress);
      });
  }
  _addOrders = async () => {
    var e = this.ordersPagination.dataset.url,
      e = await this._getOrders(e),
      t = e.querySelector(this._selectors.ordersContainer).innerHTML,
      e = e.querySelector(this._selectors.ordersPagination);
    this.ordersContainer.insertAdjacentHTML("beforeend", t),
      e
        ? (this.ordersPagination.dataset.url = e.dataset.url)
        : this.ordersPagination.remove(),
      this.ordersContainer.connectedCallback();
  };
  _getOrders(e) {
    return fetch(e)
      .then((e) => e.text())
      .then((e) => {
        return new DOMParser().parseFromString(e, "text/html");
      });
  }
  _handleDeleteAddress = (e) => {
    e = e.currentTarget.dataset.target;
    confirm("Are you sure you want to delete this address?") &&
      Shopify.postLink(e, { parameters: { _method: "delete" } });
  };
  _handleOpenEditAddress = (e) => {
    this._handleCloseEditAddress(), e.stopPropagation();
    var t = e.currentTarget.dataset.form,
      e = e.currentTarget.parentNode,
      t = document.querySelector("#editAddressForm--" + t);
    e.classList.add("hidden"),
      t.classList.remove("hidden"),
      t.querySelector('[name="address[first_name]"]').focus();
  };
  _handleCloseEditAddress = (e) => {
    e && e.preventDefault(),
      this.editAddressPrompts.forEach((e) => {
        e.classList.remove("hidden");
      }),
      this.editAddressElements.forEach((e) => {
        e.classList.add("hidden");
      });
  };
  _handleOpenAddAddress = (e) => {
    e.stopPropagation(),
      this.addAddressElements.forEach((e) => {
        e.classList.remove("hidden");
      }),
      this.openAddAddress.forEach((e) => {
        e.classList.add("hidden");
      });
  };
  _handleCancelAddAddress = (e) => {
    e.preventDefault(),
      this.addAddressElements.forEach((e) => {
        e.classList.add("hidden");
      }),
      this.openAddAddress.forEach((e) => {
        e.classList.remove("hidden");
      });
  };
}
customElements.define("s-account", Account);

class AddCartSection extends HTMLElement {
  constructor() {
    super();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  connectedCallback() {
    this.revealButton = this.querySelector('[js-reveal-button]');
    this.doubleButton = this.querySelector('[js-double-button]');
    this.quickAddWrapper = this.querySelector('[js-quick-add__wrapper]');
    this.productCardButton = this.querySelector('[js-product-card__button]');
    this.label = this.querySelector('[js-select-options]');

    if (!this.doubleButton) return;

    if (this.revealButton) {
      this.revealButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.showDoubleButton();
      });
    }

    if (this.productCardButton && this.quickAddWrapper) {
      this.productCardButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.doubleButton.classList.remove('grid-cols-2');
        this.doubleButton.classList.remove('border-black');
        this.doubleButton.classList.add('!border-white');
        this.doubleButton.classList.add('grid-cols-1');
        this.quickAddWrapper.style.display = 'none';

        this.showDoubleButton();
      });
    }

    this.labels = this.querySelectorAll('[js-select-options]');
    if (this.labels.length) {
      this.labels.forEach(label => {
        label.addEventListener('click', (e) => {
          e.stopPropagation();
          this._forceReset();
        });
      });
    } else {
    }

  }

  showDoubleButton() {
    this.doubleButton.style.display = 'grid';
    if (this.revealButton) this.revealButton.style.display = 'none';

    document.removeEventListener('click', this.handleClickOutside);
    document.addEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.doubleButton.style.display = '';
      if (this.revealButton) this.revealButton.style.display = 'flex';

      this.doubleButton.classList.remove('grid-cols-1');
      this.doubleButton.classList.add('grid-cols-2');
      this.doubleButton.classList.add('border-black');
      this.doubleButton.classList.remove('!border-white');

      if (this.quickAddWrapper) {
        this.quickAddWrapper.style.display = 'block';
      }

      document.removeEventListener('click', this.handleClickOutside);
    }
  }
  _forceReset() {
    this.doubleButton.style.display = '';
    if (this.revealButton) this.revealButton.style.display = 'flex';

    const isPDP = this instanceof AddCartSectionPDP;

    if (isPDP) {
      this.doubleButton.classList.remove('grid-cols-2');
      this.doubleButton.classList.add('grid-cols-1');
    } else {
      this.doubleButton.classList.remove('grid-cols-1');
      this.doubleButton.classList.add('grid-cols-2');
    }

    this.doubleButton.classList.add('border-black');
    this.doubleButton.classList.remove('!border-white');

    if (this.quickAddWrapper) {
      this.quickAddWrapper.style.display = 'block';
    }

    document.removeEventListener('click', this.handleClickOutside);
  }
}

customElements.define('addcart-section', AddCartSection);

class AddCartSectionPDP extends AddCartSection {
  constructor() {
    super();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this._handleQuickAddOutsideClick = this._handleQuickAddOutsideClick.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this._initPdpQuickAdd();
  }

  _initPdpQuickAdd() {
    this.cart = document.querySelector("cart-drawer");
    this.cartDrawer = document.querySelector("#CartDrawer");
    this.addToCartButtons = this.querySelectorAll("[js-add-to-cart]");
    this.quickAdd = this.querySelector("[js-quick-add]");
    this.quickAddTrigger = this.querySelector("[js-quick-add-trigger]");
    this.quickAddOptions = this.querySelector("[js-quick-add-options]");
    this.quickAddVariants = this.querySelectorAll("[js-quick-add-variant]");
    this.selectAddToCart = this.querySelectorAll("[js-select-add-to-cart]");
    this.selectAddBundle = this.querySelectorAll("[js-select-bundle-add-to-cart]");

    const productJsonEl = document.getElementById("ProductJSON");
    this._product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

    this.addToCartButtons.forEach((btn) => {
      btn.addEventListener("click", this._pdpAddToCart);
    });
    this.selectAddToCart.forEach((el) => {
      el.addEventListener("click", this._pdpSelectAddToCart);
    });
    this.selectAddBundle.forEach((el) => {
      el.addEventListener("change", this._pdpSelectAddBundleToCart);
    });
    if (this.quickAddTrigger) {
      this.quickAddTrigger.addEventListener("click", this._togglePdpQuickAdd);
      this.quickAddTrigger.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }
    this.quickAddVariants.forEach((btn) => {
      btn.addEventListener("click", this._selectPdpQuickAddVariant);
    });
  }

  _pdpCartAdd(variantId, sellingPlan) {
    const payload = {
      items: [{ id: variantId, quantity: 1 }],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    };
    if (sellingPlan) payload.items[0].selling_plan = sellingPlan;

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        document.querySelector("cart-items") &&
          document.querySelector("cart-items").onCartUpdate();
        this.cart.renderContents(data);
        if (this.cartDrawer.getAttribute("aria-hidden") == "true") {
          this.cartDrawer.open();
        }
        if (this.quickAddTrigger && this.quickAddOptions) {
          this._closePdpQuickAdd();
        }
        this.selectAddToCart.forEach((select) => {
          select.selectedIndex = 0;
        });
        return fetch(window.routes.cart_url + "?section_id=cart__main");
      })
      .then((response) => response.text())
      .then((html) => {
        this.cart.updateLiveItemCount(html);
        updateMultipleCartBubbles();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  _pdpAddToCart = (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    if (btn.dataset.variantId != "") {
      this._pdpCartAdd(btn.dataset.variantId, btn.dataset.sellingPlan);
    }
  };

  _pdpSelectAddToCart = (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    if (el.dataset.variantId != "") {
      this._pdpCartAdd(el.dataset.variantId, el.value);
    }
  };

  _pdpSelectAddBundleToCart = (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    if (el.dataset.variantId != "") {
      this._pdpBundleAdd(el.dataset.variantId, el.dataset.bundleProducts, el.value);
    }
  };

  _pdpBundleAdd(variantId, bundleProducts, planKey) {
    const payload = {
      items: [],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    };
    const bundleId = new Date();
    const bundleVariant = { id: variantId, quantity: 1 };
    const products = JSON.parse(bundleProducts);
    products.forEach((item) => {
      item.selling_plan = item[planKey];
      delete item.plan_1;
      delete item.plan_2;
      delete item.plan_3;
    });
    payload.items = products;
    payload.items.push(bundleVariant);
    payload.items.forEach((item) => {
      item.properties = { _bundleId: bundleId };
    });

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        document.querySelector("cart-items") &&
          document.querySelector("cart-items").onCartUpdate();
        this.cart.renderContents(data);
        if (this.cartDrawer.getAttribute("aria-hidden") == "true") {
          this.cartDrawer.open();
        }
        this.selectAddBundle.forEach((select) => {
          select.selectedIndex = 0;
        });
        return fetch(window.routes.cart_url + "?section_id=cart__main");
      })
      .then((response) => response.text())
      .then((html) => {
        this.cart.updateLiveItemCount(html);
        updateMultipleCartBubbles();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  _getVariantById(variantId) {
    if (!this._product || !variantId) return null;
    const id = Number(variantId);
    return this._product.variants.find((variant) => variant.id === id);
  }

  _selectPdpQuickAddVariant = (e) => {
    e.preventDefault();
    const swatch = e.currentTarget;
    const variant = this._getVariantById(swatch.dataset.variantId);

    this.addToCartButtons.forEach((btn) => {
      btn.dataset.variantId = swatch.dataset.variantId;
    });

    if (variant && this.quickAdd) {
      theme.utils.updateQuickAddBuyLabel(this.quickAdd, variant);
    }

    if (this.quickAddTrigger) {
      this.quickAddTrigger.classList.add("hidden");
    }
    if (this.quickAddOptions) {
      this.quickAddOptions.classList.add("hidden");
      this.quickAddOptions.classList.add("!opacity-0");
    }
    if (this.quickAdd) {
      this.quickAdd.classList.remove("hidden");
      this.quickAdd.focus();
    }
  };

  _togglePdpQuickAdd = () => {
    if (this.quickAddTrigger) {
      this.quickAddTrigger.classList.add("hidden");
    }
    if (this.quickAddOptions) {
      this.quickAddOptions.classList.remove("hidden");
      this.quickAddOptions.classList.remove("!opacity-0");
    }
    document.addEventListener("click", this._handleQuickAddOutsideClick);
  };

  _closePdpQuickAdd = () => {
    if (this.quickAdd) {
      this.quickAdd.classList.add("hidden");
    }
    if (this.quickAddOptions) {
      this.quickAddOptions.classList.add("hidden");
      this.quickAddOptions.classList.remove("!opacity-0");
    }
    if (this.quickAddTrigger) {
      this.quickAddTrigger.classList.remove("hidden");
    }
    this.addToCartButtons.forEach((btn) => {
      btn.dataset.variantId = "";
    });
    document.removeEventListener("click", this._handleQuickAddOutsideClick);
  };

  _handleQuickAddOutsideClick = (e) => {
    if (
      !e.target.closest("[js-quick-add-options]") &&
      !e.target.closest("[js-quick-add-trigger]")
    ) {
      this._closePdpQuickAdd();
    }
  };

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.doubleButton.style.display = '';
      if (this.revealButton) this.revealButton.style.display = 'flex';

      this.doubleButton.classList.remove('grid-cols-1');
      this.doubleButton.classList.add('border-black');
      this.doubleButton.classList.remove('!border-white');

      if (this.quickAddWrapper) {
        this.quickAddWrapper.style.display = 'block';
      }

      document.removeEventListener('click', this.handleClickOutside);
    }
  }
}

customElements.define('addcart-section-pdp', AddCartSectionPDP);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[js-reveal-password]').forEach(function (button) {
    button.addEventListener('click', function () {
      const container = button.closest('div');
      const input = container.querySelector('[js-RegisterForm-password]');
      const isVisible = input.type === 'text';

      input.type = isVisible ? 'password' : 'text';
      button.textContent = isVisible ? 'Show' : 'Hide';
    });
  });
});

class AccountToggle extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('#slider');
    this.btnCreate = this.querySelector('#btn-create');
    this.btnLogin = this.querySelector('#btn-login');
    this.contentCreate = this.querySelector('#content-create');
    this.contentLogin = this.querySelector('#content-login');

    if (!this.slider || !this.btnCreate || !this.btnLogin) return;

    this.btnCreate.addEventListener('click', () => this._activate('create'));
    this.btnLogin.addEventListener('click', () => this._activate('login'));

    // 👇 Attiva automaticamente in base all'URL
    if (window.location.pathname.includes('/login')) {
      this._activate('login');
    } else {
      this._activate('create');
    }
  }

  _activate(mode) {
    if (mode === 'create') {
      this.slider.style.transform = 'translateX(0%)';
      this.contentCreate.classList.remove('hidden');
      this.contentLogin.classList.add('hidden');
    } else {
      this.slider.style.transform = 'translateX(99.8%)';
      this.contentLogin.classList.remove('hidden');
      this.contentCreate.classList.add('hidden');
    }
  }
}

customElements.define('account-toggle', AccountToggle);







class MegaMenu extends HTMLElement {
  static all = new Set();
  static plainNavCloseBound = false;

  constructor() {
    super();
    this.closeTimer = null;
  }

  static closeAll() {
    MegaMenu.all.forEach((menu) => menu.forceClose());
  }

  static bindPlainNavCloseHandlers() {
    if (MegaMenu.plainNavCloseBound) return;
    MegaMenu.plainNavCloseBound = true;

    document.addEventListener('mouseover', (event) => {
      if (!event.target.closest('.site-header__desktop-nav')) return;

      const plainLink = event.target.closest('a.desktop-nav__parent-item');
      if (!plainLink) return;

      MegaMenu.closeAll();
    });

    document.addEventListener('focusin', (event) => {
      const plainLink = event.target.closest('a.desktop-nav__parent-item');
      if (!plainLink) return;

      MegaMenu.closeAll();
    });
  }

  connectedCallback() {
    MegaMenu.all.add(this);
    MegaMenu.bindPlainNavCloseHandlers();

    this.triggers = Array.from(
      document.querySelectorAll(`[data-drawer-id="${this.id}"]`)
    );

    this.triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "false");

      trigger.addEventListener("mouseenter", () => this.open());
      trigger.addEventListener("mouseleave", () => this.scheduleClose());
      trigger.addEventListener("focusin", () => this.open());
      trigger.addEventListener("keydown", (e) => this.onKeyDown(e));
    });

    this.addEventListener("mouseenter", () => this.open());
    this.addEventListener("mouseleave", () => this.scheduleClose());

    // close interno
    this.querySelectorAll("[js-close-child-menu]").forEach(btn => {
      btn.addEventListener("click", () => this.close());
    });
  }

  hasDropdownContent() {
    if (this.dataset.hasDropdownContent === 'false') return false;
    if (this.dataset.hasDropdownContent === 'true') return true;

    if (this.querySelector('.site-header-nav__child-menu-wrapper')) return true;
    if (this.querySelector('.blog-nav')) return true;

    const wrapper = this.querySelector('.js-product-panel-wrapper');
    return !!(wrapper && wrapper.querySelector('.header-menu-panel'));
  }

  open() {
    if (!this.hasDropdownContent()) return;

    clearTimeout(this.closeTimer);

    // chiudi gli altri menu prima
    MegaMenu.all.forEach(menu => {
      if (menu !== this) menu.forceClose();
    });

    this.classList.add("open");
    this.setAttribute("data-open", "true");
    this.triggers.forEach(t => t.setAttribute("aria-expanded", "true"));

    // aggiungo le classi al body
    document.body.classList.add("js-drawer-open", "js-drawer-child-menu-open");

    this.dispatchEvent(new CustomEvent("megamenu:open", { bubbles: true }));
  }

  scheduleClose() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      const stillOver = this.matches(":hover") || this.contains(document.activeElement);
      const overTrigger = this.triggers.some(
        t => t.matches(":hover") || t.contains(document.activeElement)
      );
      if (!stillOver && !overTrigger) this.close();
    }, 200);
  }

  close() {
    clearTimeout(this.closeTimer);
    this.forceClose();
  }

  forceClose() {
    const wasOpen = this.classList.contains("open");

    this.classList.remove("open");
    this.removeAttribute("data-open");
    this.triggers.forEach(t => t.setAttribute("aria-expanded", "false"));

    // tolgo le classi dal body se nessun menu è aperto
    const anyOpen = Array.from(MegaMenu.all).some(menu => menu.classList.contains("open"));
    if (!anyOpen) {
      document.body.classList.remove("js-drawer-open", "js-drawer-child-menu-open");
    }

    if (wasOpen) {
      this.dispatchEvent(new CustomEvent("megamenu:close", { bubbles: true }));
    }
  }

  onKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") { 
      e.preventDefault(); 
      this.open(); 
    }
    if (e.key === "Escape") { 
      e.preventDefault(); 
      this.close(); 
    }
  }
}

customElements.define("s-drawer-megamenu", MegaMenu);
